import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { Container, Row, Col, Form, Button, Badge, Card } from "react-bootstrap";
import Select from "react-select";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import '../componentCss/webform.css';
import { useNavigate } from "react-router-dom";
import Dashboardheader from './dashboardheader';
import Sidebar from './sidebar';
import '../componentCss/sidebar.css';
import { BsFillTrash3Fill, BsFilePlusFill, BsArrowLeft, BsPlus } from "react-icons/bs";
import { MdEdit, MdDelete, MdAdd, MdSave, MdInfo, MdVisibility, MdDragIndicator } from "react-icons/md";
import MasterDataPreviewModal from "./ModalComponents/MasterDataPreviewModal";
import masterDataService from "../../services/masterDataService";
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, useSortable, arrayMove } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import toast from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';
import { BsArrowLeftCircleFill } from "react-icons/bs";
import config from '../../config/config';
import { Link } from "react-router-dom";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

import {
    addWebFormFieldsAction,
    getFormListAction,
    getFieldTypeAction,
    getDepartmentAction,
    getFormDetailsAction,
    getFormFieldsDataAction,
    updateWebFormAction,
    deleteWebFormFieldAction,
    getCategoryListForWebFormAction,
    getMasterListAction,
    getMasterTableColumnAction
} from '../../Action/modernAdminActions';

// Import decryption utility for legacy API responses
import { decryptData } from "./decrypt";

// Import version management component
import formTemplateService from '../../services/formTemplateService';

// Import formula builder utilities
import {
  evaluateFormula,
  parseFormulaFields,
  validateFormulaSyntax,
  detectCircularDependency
} from "../../utils/formulaBuilder";


let fieldArr = [];
let radioFieldValueArr = [];
let radioAddFieldArr = [
    [{ radioCheckboxValue: "" }]
]

// ImageOptionPreview component for displaying image options with expand/collapse functionality
const ImageOptionPreview = ({ imageUrl, label }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="position-relative d-inline-block ms-2">
      <img
        src={imageUrl}
        alt={label}
        onClick={() => setExpanded(!expanded)}
        style={{
          width: expanded ? '300px' : '50px',
          height: expanded ? 'auto' : '50px',
          objectFit: 'cover',
          borderRadius: '4px',
          border: '2px solid #0d6efd',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: expanded ? '0 4px 8px rgba(0,0,0,0.2)' : 'none',
          zIndex: expanded ? 1000 : 1,
          position: expanded ? 'absolute' : 'static',
          left: expanded ? 0 : 'auto',
          top: expanded ? 0 : 'auto'
        }}
      />
      {expanded && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100"
          style={{
            backgroundColor: 'rgba(0,0,0,0.3)',
            zIndex: 999
          }}
          onClick={() => setExpanded(false)}
        />
      )}
    </div>
  );
};

// Field Configuration Map for dynamic field type management with validation
const FIELD_CONFIG_MAP = {
    text: {
        controls: ['placeholder', 'required', 'min_length', 'max_length', 'default', 'validation'],
        defaults: {
            field_type: 'text',
            options: [],
            placeholder: '',
            required: false,
            validation: {
                required_message: 'This field is required',
                min_length_message: 'Text is too short',
                max_length_message: 'Text is too long',
                pattern: '',
                pattern_message: 'Please enter a valid format'
            }
        },
        needsOptions: false,
        inputType: 'text'
    },
    textarea: {
        controls: ['placeholder', 'required', 'min_length', 'max_length', 'default', 'validation'],
        defaults: {
            field_type: 'textarea',
            options: [],
            placeholder: '',
            required: false,
            validation: {
                required_message: 'This field is required',
                min_length_message: 'Text is too short',
                max_length_message: 'Text is too long'
            }
        },
        needsOptions: false,
        inputType: 'textarea'
    },
    number: {
        controls: ['min_value', 'max_value', 'step', 'required', 'default', 'validation'],
        defaults: {
            field_type: 'number',
            options: [],
            min_value: null,
            max_value: null,
            required: false,
            validation: {
                required_message: 'This field is required',
                min_value_message: 'Number is too small',
                max_value_message: 'Number is too large',
                invalid_number_message: 'Please enter a valid number',
                pattern: '',
                pattern_message: 'Please enter a valid number format'
            }
        },
        needsOptions: false,
        inputType: 'number'
    },
    email: {
        controls: ['placeholder', 'required', 'default', 'validation'],
        defaults: {
            field_type: 'email',
            options: [],
            placeholder: '',
            required: false,
            validation: {
                required_message: 'This field is required',
                invalid_email_message: 'Please enter a valid email address'
            }
        },
        needsOptions: false,
        inputType: 'email'
    },
    phone: {
        controls: ['placeholder', 'required', 'default', 'validation'],
        defaults: {
            field_type: 'phone',
            options: [],
            placeholder: '',
            required: false,
            validation: {
                required_message: 'This field is required',
                invalid_phone_message: 'Please enter a valid phone number',
                pattern: '',
                pattern_message: 'Please enter a valid phone format'
            }
        },
        needsOptions: false,
        inputType: 'tel'
    },
    url: {
        controls: ['placeholder', 'required', 'default', 'validation'],
        defaults: {
            field_type: 'url',
            options: [],
            placeholder: '',
            required: false,
            validation: {
                required_message: 'This field is required',
                invalid_url_message: 'Please enter a valid URL'
            }
        },
        needsOptions: false,
        inputType: 'url'
    },
    date: {
        controls: ['min_value', 'max_value', 'required', 'default', 'validation'],
        defaults: {
            field_type: 'date',
            options: [],
            min_value: null,
            max_value: null,
            required: false,
            validation: {
                required_message: 'This field is required',
                min_date_message: 'Date is too early',
                max_date_message: 'Date is too late',
                invalid_date_message: 'Please enter a valid date'
            }
        },
        needsOptions: false,
        inputType: 'date'
    },
    time: {
        controls: ['min_value', 'max_value', 'required', 'default', 'validation'],
        defaults: {
            field_type: 'time',
            options: [],
            required: false,
            validation: {
                required_message: 'This field is required',
                min_time_message: 'Time is too early',
                max_time_message: 'Time is too late',
                invalid_time_message: 'Please enter a valid time'
            }
        },
        needsOptions: false,
        inputType: 'time'
    },
    datetime: {
        controls: ['min_value', 'max_value', 'required', 'default', 'validation'],
        defaults: {
            field_type: 'datetime',
            options: [],
            required: false,
            validation: {
                required_message: 'This field is required',
                min_datetime_message: 'Date and time is too early',
                max_datetime_message: 'Date and time is too late',
                invalid_datetime_message: 'Please enter a valid date and time'
            }
        },
        needsOptions: false,
        inputType: 'datetime-local'
    },
    dropdown: {
        controls: ['options', 'allowOther', 'default', 'required', 'validation'],
        defaults: {
            field_type: 'dropdown',
            options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
            allowOther: false,
            required: false,
            validation: {
                required_message: 'Please select an option'
            }
        },
        needsOptions: true,
        inputType: 'select'
    },
    select_manual: {
        controls: ['options', 'allowOther', 'default', 'required', 'validation'],
        defaults: {
            field_type: 'select_manual',
            options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
            allowOther: false,
            required: false,
            validation: {
                required_message: 'Please select an option'
            }
        },
        needsOptions: true,
        inputType: 'select'
    },
    multiselect: {
        controls: ['options', 'allowOther', 'default', 'required', 'validation'],
        defaults: {
            field_type: 'multiselect',
            options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
            allowOther: false,
            required: false,
            validation: {
                required_message: 'Please select at least one option'
            }
        },
        needsOptions: true,
        inputType: 'multiselect'
    },
    radio: {
        controls: ['options', 'layout', 'default', 'required', 'validation'],
        defaults: {
            field_type: 'radio',
            options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
            layout: 'column',
            required: false,
            validation: {
                required_message: 'Please select an option'
            }
        },
        needsOptions: true,
        inputType: 'radio'
    },
    checkbox: {
        controls: ['options', 'layout', 'default', 'required', 'validation'],
        defaults: {
            field_type: 'checkbox',
            options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
            layout: 'column',
            required: false,
            validation: {
                required_message: 'Please select at least one option'
            }
        },
        needsOptions: true,
        inputType: 'checkbox'
    },
    checkboxes: {
        controls: ['options', 'layout', 'default', 'required', 'validation'],
        defaults: {
            field_type: 'checkboxes',
            options: [{ label: 'Option 1', value: 'option1', imageUrl: null }],
            layout: 'column',
            required: false,
            validation: {
                required_message: 'Please select at least one option'
            }
        },
        needsOptions: true,
        inputType: 'checkbox'
    },
    toggle: {
        controls: ['labelOn', 'labelOff', 'default', 'required', 'validation'],
        defaults: {
            field_type: 'toggle',
            options: [],
            labelOn: 'Yes',
            labelOff: 'No',
            required: false,
            validation: {
                required_message: 'Please make a selection'
            }
        },
        needsOptions: false,
        inputType: 'checkbox'
    },
    file: {
        controls: ['accept', 'maxSize', 'maxQuantity', 'required', 'validation'],
        defaults: {
            field_type: 'file',
            options: [],
            accept: '*/*',
            maxSize: 5,
            maxQuantity: 1,
            required: false,
            validation: {
                required_message: 'Please select a file',
                invalid_file_type_message: 'File type not allowed',
                file_too_large_message: 'File size exceeds limit',
                too_many_files_message: 'Too many files selected'
            }
        },
        needsOptions: false,
        inputType: 'file'
    },
    lookup: {
        controls: ['sourceKey', 'valueMapping', 'labelMapping', 'debounce', 'required', 'validation'],
        defaults: {
            field_type: 'lookup',
            options: [],
            sourceKey: '',
            valueMapping: '',
            labelMapping: '',
            debounce: 300,
            required: false,
            validation: {
                required_message: 'This field is required',
                no_results_message: 'No matching results found'
            }
        },
        needsOptions: false,
        inputType: 'text'
    },
    signature: {
        controls: ['required', 'validation'],
        defaults: {
            field_type: 'signature',
            options: [],
            required: false,
            validation: {
                required_message: 'Please provide your signature'
            }
        },
        needsOptions: false,
        inputType: 'signature'
    },
    header: {
        controls: [],
        defaults: {
            field_type: 'header',
            options: [],
            required: false
        },
        needsOptions: false,
        inputType: 'header'
    },
    file_upload: {
        controls: ['accept', 'maxSize', 'maxQuantity', 'required', 'validation'],
        defaults: {
            field_type: 'file_upload',
            options: [],
            accept: '*/*',
            maxSize: 5,
            maxQuantity: 1,
            required: false,
            validation: {
                required_message: 'Please select a file',
                invalid_file_type_message: 'File type not allowed',
                file_too_large_message: 'File size exceeds limit',
                too_many_files_message: 'Too many files selected'
            }
        },
        needsOptions: false,
        inputType: 'file'
    },
    formula: {
        controls: ['formula_builder', 'decimal_places', 'prefix', 'suffix', 'show_formula', 'validation'],
        defaults: {
            field_type: 'formula',
            options: [],
            formula_expression: '',
            referenced_field_ids: [],
            decimal_places: 2,
            prefix: '',
            suffix: '',
            show_formula: false,
            read_only: true,
            required: false,
            calculated_value: null,
            formula_error: null,
            validation: {
                invalid_formula_message: 'Formula contains errors',
                missing_field_message: 'Referenced field does not exist',
                division_by_zero_message: 'Division by zero error'
            }
        },
        needsOptions: false,
        inputType: 'formula'
    },
    markdown: {
        controls: ['markdown_editor'],
        defaults: {
            field_type: 'markdown',
            label: '# Heading\n\nYour **markdown** content here...',
            help_text: '',
            options: [],
            required: false
        },
        needsOptions: false,
        inputType: 'markdown'
    }
};

// Helper function to generate unique field IDs
const generateFieldId = (label, existingFields) => {
    if (!label) return '';

    let baseId = label.toLowerCase()
        .replace(/[^a-z0-9\s]/g, '') // Remove special characters
        .replace(/\s+/g, '_') // Replace spaces with underscores
        .substring(0, 50); // Limit length

    // Ensure uniqueness
    let counter = 1;
    let fieldId = baseId;
    while (existingFields.some(field => field.id === fieldId || field.name === fieldId)) {
        fieldId = `${baseId}_${counter}`;
        counter++;
    }

    return fieldId;
};

// Helper function to generate stable option values
const generateOptionValue = (label) => {
    if (!label) return '';
    return label.toLowerCase()
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, '_')
        .substring(0, 30);
};

// Helper function to get field type ID for display in dropdown
// Dynamically computes the ID from the field's type name by matching against formFieldTypeList
const getFieldTypeIdForDisplay = (field, formFieldTypeList) => {
    const fieldTypeName = field.fieldtype || field.field_type;
    if (!fieldTypeName) return "";

    // Try to find matching field type in the list
    const matchedType = Array.isArray(formFieldTypeList)
        ? formFieldTypeList.find(ft => (ft.fieldType || ft.name) === fieldTypeName)
        : null;

    return matchedType ? matchedType.id : "";
};

// Function to validate all fields for submission
const validateAllFields = (fields) => {
    const allErrors = {};
    let hasErrors = false;

    fields.forEach((field, index) => {
        const fieldErrors = validateField(field, index, true); // Use submission validation
        if (Object.keys(fieldErrors).length > 0) {
            allErrors[index] = fieldErrors;
            hasErrors = true;
        }
    });

    return { errors: allErrors, hasErrors };
};

// Field validation function
const validateField = (field, index, isSubmissionValidation = false) => {
    const errors = {};

    // For real-time validation, only validate if field has been edited
    // For submission validation, validate all fields regardless of edit status
    const hasBeenEdited = (field.label && field.label.trim() !== '') || (field.field_type && field.field_type !== '');

    if (!isSubmissionValidation && !hasBeenEdited) {
        return errors; // Don't validate empty/untouched fields during real-time validation
    }

    // Always validate required fields during submission, even if empty
    if (!field.label || field.label.trim() === '') {
        errors.label = 'Field label is required';
    }

    if (!field.field_type || field.field_type === '') {
        errors.field_type = 'Field type is required';
    }

    const config = FIELD_CONFIG_MAP[field.field_type];
    if (config && config.needsOptions && field.field_type) {
        if (!field.options || field.options.length === 0) {
            errors.options = 'At least one option is required for this field type';
        } else {
            // Check for empty options
            const emptyOptions = field.options.filter(opt => !opt.label || opt.label.trim() === '');
            if (emptyOptions.length > 0) {
                errors.options = 'All options must have labels';
            }

            // Check for duplicate option values
            const values = field.options.map(opt => opt.value).filter(Boolean);
            const uniqueValues = [...new Set(values)];
            if (values.length !== uniqueValues.length && values.length > 0) {
                errors.options = 'Option values must be unique';
            }
        }
    }

    return errors;
};

// Sortable Field Item Component for drag & drop
const SortableFieldItem = ({ id, children }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        cursor: isDragging ? 'grabbing' : 'default'
    };

    const dragHandleProps = { ...attributes, ...listeners };

    return (
        <div ref={setNodeRef} style={style}>
            {/* Pass drag handle props to children as a function */}
            {typeof children === 'function' ? children(dragHandleProps) : children}
        </div>
    );
};

const EditWebForm = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams(); // React Router hook - reactive to URL changes
    const versionFromUrl = searchParams.get('version') || '1';
    const navigate = useNavigate();
    const location = useLocation(); // Detect navigation changes

    // Early validation of the ID from URL params
    useEffect(() => {
        if (!id || id === 'undefined' || id === 'null') {
            toast.error('Invalid form ID in URL. Redirecting to forms list.');
            navigate(`${config.baseUrl}webforms`);
            return;
        }
    }, [id, navigate]);

    // Update currentFormVersion when versionFromUrl changes
    useEffect(() => {
        console.log('🔍 Version from URL:', versionFromUrl);
        setCurrentFormVersion(versionFromUrl);
    }, [versionFromUrl]);
    const [formData, setForm] = useState({
        name: '',
        description: '',
        department_id: '',
        category_id: '',
        is_active: true,
        version: '1',
        // Legacy compatibility fields
        formName: '',
        formCategory: '',
        formNumber: '',
        departmentId: 0,
        formTypeId: 0,
        isSideBarAccess: 0,
        isLateEntry: 0,
        lateEntryTime: 0,
        isCallToAction: 0,
        callToActionLink: 0
    })
    const [formNumber, setformNumber] = useState('')
    const [formValues, setFormValues] = useState([{
        field_id: "",
        label: "",
        field_type: "",
        required: false,
        placeholder: null,
        help_text: "",
        options: [],
        min_length: null,
        max_length: null,
        min_value: null,
        max_value: null,
        order: 0,
        // Legacy compatibility fields
        fieldtypeId: "",
        fieldtype: "",
        fieldName: "",
        action: '',
        isMandatory: false,
        isAddMore: 0,
        description: '',
        fieldValue: '',
        formType: '',
        radioCheckbox: [],
        isFieldSorting: ''
    }])
    const [formRadioCheckbox, setFormRadioCheckbox] = useState([{ radioCheckboxValue: "" }])
    const [formfieldsList, setFormfieldsList] = useState([])
    const [formFieldTypeList, setFormFieldTypeList] = useState([])
    const [departmentList, setDepartmentList] = useState([])
    const [formList, setFormList] = useState([])
    const [rowIndex, setRowIndex] = useState(0)
    const [existingFormFields, setExistingFormFields] = useState([])
    const [formCategoryList, setFormCategoryList] = useState([]);
    const [masterList, setMasterData] = useState([]);

    // Version management state
    const [currentFormVersion, setCurrentFormVersion] = useState(versionFromUrl);
    const [formVersionInfo, setFormVersionInfo] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    const [columDataList, setColumDataList] = useState([])
    const [isFetching, setIsFetching] = useState(false);
    const [formField, setFormField] = useState([]);

    // Master Data Integration State
    const [masterDataTables, setMasterDataTables] = useState([]);
    const [masterDataColumns, setMasterDataColumns] = useState({});
    const [previewModalData, setPreviewModalData] = useState({
        visible: false,
        fieldLabel: '',
        options: [],
        tableName: '',
        columnName: ''
    });

    // Drag & drop sensors configuration
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 8, // 8px movement required before drag starts
            },
        })
    );

    // Normalize API field -> editor field shape used by UI
    const normalizeFieldFromApi = (apiField, index) => {
        const resolvedFieldType = apiField.field_type || '';
        const matchedType = Array.isArray(formFieldTypeList)
            ? formFieldTypeList.find(ft => (ft.fieldType || ft.name) === resolvedFieldType)
            : null;
        const fieldTypeId = matchedType ? matchedType.id : '';

        // Parse and normalize options with proper error handling
        let normalizedOptions = [];
        try {
            if (Array.isArray(apiField.options)) {
                // Deep clone to avoid reference issues
                normalizedOptions = JSON.parse(JSON.stringify(apiField.options));
            } else if (typeof apiField.options === 'string' && apiField.options.trim()) {
                // Parse if it's a JSON string
                normalizedOptions = JSON.parse(apiField.options);
                // Ensure it's an array after parsing
                if (!Array.isArray(normalizedOptions)) {
                    normalizedOptions = [];
                }
            } else if (apiField.radioCheckbox) {
                // Fallback to radioCheckbox field for legacy compatibility
                if (Array.isArray(apiField.radioCheckbox)) {
                    normalizedOptions = JSON.parse(JSON.stringify(apiField.radioCheckbox));
                } else if (typeof apiField.radioCheckbox === 'string' && apiField.radioCheckbox.trim()) {
                    normalizedOptions = JSON.parse(apiField.radioCheckbox);
                }
            }
        } catch (e) {
            console.error('Error parsing options for field:', apiField.label || apiField.field_name, e);
            normalizedOptions = [];
        }

        // Ensure all options have proper label and value structure
        normalizedOptions = normalizedOptions.map(opt => {
            if (typeof opt === 'object' && opt !== null) {
                return {
                    label: opt.label || opt.value || '',
                    value: opt.value || opt.label || '',
                    imageUrl: opt.imageUrl || opt.image_url || null
                };
            }
            // Handle string options
            return {
                label: String(opt),
                value: String(opt).toLowerCase().replace(/\s+/g, '_'),
                imageUrl: null
            };
        }).filter(opt => opt.label && opt.value); // Remove invalid options

        return {
            // Modern model
            field_id: apiField.field_id || '',
            label: apiField.label || apiField.field_name || '',
            field_type: resolvedFieldType,
            required: !!(apiField.required || apiField.is_mandatory === 1),
            placeholder: apiField.placeholder ?? '',
            help_text: apiField.help_text ?? '',
            options: normalizedOptions,
            min_length: apiField.min_length ?? null,
            max_length: apiField.max_length ?? null,
            min_value: apiField.min_value ?? null,
            max_value: apiField.max_value ?? null,
            step: apiField.step ?? null,
            order: apiField.order ?? index,
            validation: apiField.validation || {},

            // Formula-specific properties
            formula_expression: apiField.formula_expression ?? '',
            referenced_field_ids: apiField.referenced_field_ids ?? [],
            decimal_places: apiField.decimal_places ?? 2,
            prefix: apiField.prefix ?? '',
            suffix: apiField.suffix ?? '',
            show_formula: apiField.show_formula ?? false,
            calculated_value: apiField.calculated_value ?? null,
            formula_error: null, // Reset error on load

            // Legacy/compat mirror fields the editor references
            id: apiField.field_id || apiField.id || '',
            fieldtypeId: fieldTypeId,
            fieldtype: resolvedFieldType,
            fieldName: apiField.field_name || apiField.label || '',
            isMandatory: !!(apiField.is_mandatory || apiField.required),
            isAddMore: apiField.is_add_more ?? 0,
            description: apiField.field_description || apiField.help_text || '',
            fieldValue: '',
            formType: apiField.form_type || '',
            radioCheckbox: [],
            isFieldSorting: apiField.order ?? index
        };
    };

    const validateForm = () => {
        // Basic validation stub; existing detailed validation runs elsewhere
        return !!(formData?.name && formData?.department_id && formData?.category_id);
    };

    // Helper functions to get names from IDs
    const getDepartmentName = (departmentId) => {
        const dept = departmentList.find(d => d.id === departmentId);
        return dept ? (dept.name || dept.department_name || 'Unknown') : 'Unknown';
    };

    const getCategoryName = (categoryId) => {
        const category = formCategoryList.find(c => c.id === categoryId);
        return category ? (category.name || category.category_name || 'Unknown') : 'Unknown';
    };

    useEffect(() => {
        // Load reference data first, then form data
        const loadData = async () => {
            // Only fetch if ID exists
            if (!id) {
                console.warn('No form ID found, skipping data load');
                return;
            }

            await Promise.all([
                getFieldTypeAPI(),
                getDepartmentAPI(),
                getFormListAPI(),
                getFormCategoryAPI(),
                getMasterList(),
                fetchMasterDataTables()
            ]);
            // Load form data after reference data is available
            await getFormFieldsData();
        };
        loadData();
    }, [id, currentFormVersion, location.key]); // Refetch when ID OR version changes OR navigation occurs

    // Force re-render when reference data is loaded
    useEffect(() => {
        if (departmentList.length > 0 && formCategoryList.length > 0 && formData.name) {
            // Trigger a re-render by updating state slightly
            setForm(prev => ({ ...prev }));
        }
    }, [departmentList, formCategoryList]);

    // Load version info when form ID is available (only once)
    useEffect(() => {
        const loadVersionInfo = async () => {
            try {
                const versionInfo = await formTemplateService.getFormVersionInfo(id);
                if (versionInfo.success) {
                    console.log('🔍 Version info loaded:', versionInfo.data);
                    // NOTE: Removed setCurrentFormVersion to prevent race condition
                    // Let URL param be the source of truth for version instead
                    // console.log('🔍 Setting current version to:', versionInfo.data.latest_version || 'v1');
                    setFormVersionInfo(versionInfo.data);
                    // setCurrentFormVersion(versionInfo.data.latest_version || '1');
                }
            } catch (error) {
                console.error('Error loading version info:', error);
            }
        };
        if (id && !formVersionInfo) { // Only load if not already loaded
            loadVersionInfo();
        }
    }, [id, formVersionInfo]);


    let getMasterList = async () => {
        let res = await getMasterListAction();
        setIsLoading(false)
        if (res.success) {
            setMasterData(res.data);
        }
    }

    // =========================================================================
    // MASTER DATA INTEGRATION FUNCTIONS
    // =========================================================================

    // Fetch available master data tables for dropdown configuration
    const fetchMasterDataTables = async () => {
        try {
            const response = await getMasterListAction({ page: 1, page_size: 1000 });

            if (response && response.data) {
                // Handle nested response structure from backend
                // Backend returns: { message, data: { tables: [...], total, page, ... } }
                const tablesData = response.data?.data?.tables || response.data?.tables || response.data || [];

                const tables = tablesData.map(table => ({
                    value: table.table_id,
                    label: table.display_name || table.name || table.table_id,
                    category: table.category,
                    totalRecords: table.total_records
                }));

                setMasterDataTables(tables);
            }
        } catch (error) {
            console.error('Error fetching master data tables:', error);
            toast.error('Failed to load master data tables');
        }
    };

    // Fetch columns for a specific table
    const fetchMasterDataColumns = async (tableId) => {
        try {
            const response = await getMasterTableColumnAction({ name: tableId });

            if (response && response.data && response.data.columns) {
                const columns = response.data.columns.map(col => ({
                    value: col.column_id,
                    label: col.display_name || col.column_id,
                    dataType: col.data_type
                }));

                setMasterDataColumns(prev => ({
                    ...prev,
                    [tableId]: columns
                }));
            }
        } catch (error) {
            console.error('Error fetching table columns:', error);
            toast.error('Failed to load table columns');
        }
    };

    // Fetch preview count of options
    const fetchMasterDataPreviewCount = async (tableId, columnId, fieldIndex) => {
        try {
            const response = await masterDataService.getColumnOptions(tableId, columnId);

            const updatedFields = [...existingFormFields];
            updatedFields[fieldIndex].masterDataPreviewCount = response.data?.length || 0;

            setExistingFormFields(updatedFields);
        } catch (error) {
            console.error('Error fetching preview count:', error);
        }
    };

    // Preview master data options in modal
    const previewMasterDataOptions = async (fieldIndex) => {
        const field = existingFormFields[fieldIndex];

        if (!field.master_data_table || !field.master_data_column) {
            return;
        }

        try {
            const response = await masterDataService.getColumnOptions(
                field.master_data_table,
                field.master_data_column
            );

            // Find table name
            const table = masterDataTables.find(t => t.value === field.master_data_table);

            // Backend returns: { success, message, data: { options, total, limit, offset } }
            // response.data contains the backend response
            const options = response.data?.data?.options || response.data?.options || [];

            setPreviewModalData({
                visible: true,
                fieldLabel: field.label || field.fieldName,
                options: options,
                tableName: table?.label || field.master_data_table,
                columnName: field.master_data_column
            });
        } catch (error) {
            console.error('Error loading preview:', error);
            toast.error('Failed to load options preview');
        }
    };

    // Toggle master data mode for a field
    const toggleMasterData = (e, fieldIndex) => {
        const checked = e.target.checked;
        const updatedFields = [...existingFormFields];
        const field = updatedFields[fieldIndex];

        field.useMasterData = checked;

        if (checked) {
            // Clear static options when switching to master data
            field.options = [];
        } else {
            // Clear master data references when switching to static
            field.master_data_table = "";
            field.master_data_column = "";
        }

        setExistingFormFields(updatedFields);
    };

    // Handle master table selection
    const handleMasterTableChange = async (selected, fieldIndex) => {
        const updatedFields = [...existingFormFields];
        const field = updatedFields[fieldIndex];

        field.master_data_table = selected ? selected.value : "";
        field.master_data_column = ""; // Reset column when table changes

        setExistingFormFields(updatedFields);

        // Fetch columns for selected table
        if (selected) {
            await fetchMasterDataColumns(selected.value);
        }
    };

    // Handle master column selection
    const handleMasterColumnChange = async (selected, fieldIndex) => {
        const updatedFields = [...existingFormFields];
        const field = updatedFields[fieldIndex];

        field.master_data_column = selected ? selected.value : "";

        setExistingFormFields(updatedFields);

        // Fetch preview count
        if (selected && field.master_data_table) {
            await fetchMasterDataPreviewCount(field.master_data_table, selected.value, fieldIndex);
        }
    };

    let getFormDataListAPI = async (value, index) => {
        setIsLoading(true);
        try {
            let res = await getMasterTableColumnAction({ name: value });
            setIsLoading(false);

            if (res?.success) {
                let columnData = res.data;
                setFormValues((prev) =>
                    prev.map((item, idx) =>
                        idx === index ? { ...item, columDataList: columnData } : item
                    )
                );
            } else {
                setColumDataList([]);
            }
        } catch (error) {
            setIsLoading(false);
        }
    };


    let handleChangeForm = (e) => {
        let { name, value } = e.target
        // Note: Removed form type dependency as it's not needed for modern forms

        setForm((old) => {
            const newForm = { ...old, [name]: value };
            return newForm;
        })
    }

    let getFormCategoryAPI = async () => {
        let res = await getCategoryListForWebFormAction();
        if (res.success) {
            // Log the structure of the first category to see the format
            if (res.data && res.data.length > 0) {
            }
            setFormCategoryList(res.data || []);
        }
    };

    let getFormFieldsData = async () => {
        try {
            setIsFetching(true);
            console.log('🔍 Fetching form data for form_id:', id, 'version:', currentFormVersion);
            const res = await getFormDetailsAction(id, currentFormVersion);
            if (res.success && res.data) {
                const formData = res.data;
                setForm({
                    ...formData,
                    name: formData.name || '',
                    description: formData.description || '',
                    department_id: formData.department_id || '',
                    category_id: formData.category_id || '',
                    is_active: !!formData.is_active,
                    version: formData.version || currentFormVersion || '1',
                    formName: formData.name || '',
                    formCategory: formData.category_id || '',
                    formNumber: formData.form_id || id,
                    departmentId: formData.department_id || 0,
                    formTypeId: 0,
                    isSideBarAccess: 0,
                    isLateEntry: 0,
                    lateEntryTime: 0,
                    isCallToAction: 0,
                    callToActionLink: 0
                })
                // Editor uses existingFormFields to render fields; map API -> editor shape
                const apiFields = Array.isArray(formData.fields) ? formData.fields : [];
                const normalizedExisting = apiFields.map((f, index) => normalizeFieldFromApi(f, index));
                setExistingFormFields(normalizedExisting);

                // Keep separate minimal state used for submission/update logic
                setFormField(apiFields.map((f, index) => ({
                    ...f,
                    order: f.order ?? index
                })));
            } else {
                toast.error(res.message || 'Failed to load form');
            }
        } catch (error) {
            console.error('Error loading form:', error);
            toast.error('Failed to load form');
        } finally {
            setIsFetching(false);
        }
    }

    const handleChangeData = (index, e) => {
        const { name, value } = e.target;

        // Update the form values based on index
        setFormValues((prev) =>
            prev.map((item, idx) =>
                idx === index ? { ...item, [name]: value } : item
            )
        );

        // Additional logic can be added here if needed for further indexing
    };

    let getFormFieldsListAPI = async (index, formId) => {
        let res = await getFormDetailsAction(formId, currentFormVersion);
        if (res.success) {
            fieldArr[index] = res.data;
            setFormfieldsList(res.data);
        }
    }

    let getFormListAPI = async () => {
        let res = await getFormListAction();
        if (res.success) {
            setFormList(res.data);
        }
    }

    let getDepartmentAPI = async () => {
        let res = await getDepartmentAction();
        if (res.success) {
            // Log the structure of the first department to see the format
            if (res.data && res.data.length > 0) {
            }
            setDepartmentList(res.data);
        }
    }

    // Version management functions
    const loadFormVersionInfo = async (forceRefresh = false) => {
        if (id && (forceRefresh || !formVersionInfo)) {
            try {
                const versionInfo = await formTemplateService.getFormVersionInfo(id);
                if (versionInfo.success) {
                    setFormVersionInfo(versionInfo.data);
                    setCurrentFormVersion(versionInfo.data.latest_version || '1');
                }
            } catch (error) {
                console.error('Error loading version info:', error);
            }
        }
    };

    const handleVersionChange = (newVersion) => {
        // When a new version is created, reload the form data for that version
        if (newVersion?.version) {
            setCurrentFormVersion(newVersion.version);
        }
        // Refresh version info when a new version is created
        loadFormVersionInfo(true);
        getFormFieldsData();
        toast.success(`Form version ${newVersion.version} created successfully`);
    };

    const handleVersionSelect = async (selectedVersion) => {
        try {
            console.log('🔍 Switching to version:', selectedVersion);
            // Switch to selected version and reload
            setCurrentFormVersion(selectedVersion);
            await getFormFieldsData();
            toast.success(`Switched to editing version ${selectedVersion}`);
        } catch (error) {
            console.error('Error switching version:', error);
            toast.error('Failed to switch to selected version');
        }
    };

    let handleChangeTable = (index, e) => {
        const { name, value } = e.target;

        // Update the form values based on index
        setFormValues((prev) =>
            prev.map((item, idx) =>
                idx === index ? { ...item, [name]: value } : item
            )
        );

        // Call the master list retrieval function with the selected value
        getMasterListForName(index, value);
    };

    let getMasterListForName = async (index, id) => {
        let res = await getMasterListAction();
        setIsLoading(false);

        if (res.success) {
            let data = res.data || [];

            // Filter the data based on the provided ID
            let filterData = data.filter((item) => item.id == id);

            // Fetch related form data for the corresponding dbTable
            if (filterData.length > 0) {
                getFormDataListAPI(filterData[0].dbTable, index);
            }
        }
    };


    let getFieldTypeAPI = async () => {
        let res = await getFieldTypeAction();
        let fieldTypes = [];

        if (res.success) {
            // Handle both modern (plain data) and legacy (encrypted data) formats
            const data = res.data;
            if (Array.isArray(data)) {
                // Modern format - data is already decrypted
                fieldTypes = data;
            } else if (data && Array.isArray(data.items)) {
                // Modern paginated format
                fieldTypes = data.items;
            } else if (typeof data === "string") {
                // Legacy format - data needs decryption
                const decryptedData = decryptData(data);
                fieldTypes = Array.isArray(decryptedData) ? decryptedData : [];
            } else {
                // Fallback - ensure we always set an array
                fieldTypes = Array.isArray(data) ? data : [];
            }
        }

        // Add formula field type if not already present (frontend-only field type)
        const hasFormula = fieldTypes.some(f =>
            f.fieldType === 'formula' ||
            f.name === 'Formula' ||
            f.name === 'formula'
        );

        if (!hasFormula) {
            fieldTypes.push({
                id: 'formula_field_type',  // Unique ID for formula field type
                name: 'Formula',            // Display name in dropdown
                fieldType: 'formula'        // Maps to FIELD_CONFIG_MAP key
            });
        }

        setFormFieldTypeList(fieldTypes.length > 0 ? fieldTypes : []);
    }

    // Options management functions for choice fields
    const addOptionToExisting = (fieldIndex) => {
        let newFormValues = [...existingFormFields];
        const field = newFormValues[fieldIndex];

        if (!field.options) {
            field.options = [];
        }

        const newOptionNumber = field.options.length + 1;
        const newOption = {
            label: `Option ${newOptionNumber}`,
            value: generateOptionValue(`Option ${newOptionNumber}`),
            imageUrl: null
        };

        field.options.push(newOption);
        setExistingFormFields(newFormValues);
    };

    const removeOptionFromExisting = (fieldIndex, optionIndex) => {
        let newFormValues = [...existingFormFields];
        const field = newFormValues[fieldIndex];

        if (field.options && field.options.length > 1) { // Keep at least one option
            field.options.splice(optionIndex, 1);
            setExistingFormFields(newFormValues);
        }
    };

    const updateOptionInExisting = (fieldIndex, optionIndex, property, value) => {
        let newFormValues = [...existingFormFields];
        const field = newFormValues[fieldIndex];

        if (field.options && field.options[optionIndex]) {
            field.options[optionIndex][property] = value;

            // Auto-generate value from label if value property is being updated and it's empty
            if (property === 'label' && (!field.options[optionIndex].value || field.options[optionIndex].value === '')) {
                field.options[optionIndex].value = generateOptionValue(value);
            }

            setExistingFormFields(newFormValues);

            // Validate field after option update
            const fieldErrors = validateField(field, fieldIndex);
            setFieldErrors(prev => {
                const newErrors = { ...prev };
                if (Object.keys(fieldErrors).length > 0) {
                    newErrors[fieldIndex] = fieldErrors;
                } else {
                    delete newErrors[fieldIndex];
                }
                return newErrors;
            });
        }
    };

    const moveOptionInExisting = (fieldIndex, optionIndex, direction) => {
        let newFormValues = [...existingFormFields];
        const field = newFormValues[fieldIndex];

        if (!field.options || field.options.length < 2) return;

        const newIndex = direction === 'up' ? optionIndex - 1 : optionIndex + 1;

        if (newIndex >= 0 && newIndex < field.options.length) {
            // Swap options
            const temp = field.options[optionIndex];
            field.options[optionIndex] = field.options[newIndex];
            field.options[newIndex] = temp;

            setExistingFormFields(newFormValues);
        }
    };

    // Image upload handler for option images
    const uploadOptionImage = async (file, fieldIndex, optionIndex) => {
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        try {
            // TODO: Replace with actual upload API endpoint
            const response = await fetch(`${config.API_URL}/api/upload/image`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
                body: formData
            });

            if (!response.ok) {
                throw new Error('Upload failed');
            }

            const data = await response.json();

            // Update option with image URL
            let newFormValues = [...existingFormFields];
            if (newFormValues[fieldIndex].options[optionIndex]) {
                newFormValues[fieldIndex].options[optionIndex].imageUrl = data.url || data.imageUrl || URL.createObjectURL(file);
                setExistingFormFields(newFormValues);
                toast.success('Image uploaded successfully');
            }
        } catch (error) {
            console.error('Image upload failed:', error);
            toast.error('Failed to upload image. Please try again.');
        }
    };

    const removeOptionImage = (fieldIndex, optionIndex) => {
        let newFormValues = [...existingFormFields];
        if (newFormValues[fieldIndex].options[optionIndex]) {
            newFormValues[fieldIndex].options[optionIndex].imageUrl = null;
            setExistingFormFields(newFormValues);
            toast.success('Image removed');
        }
    };

    // Function to add new field
    const addNewField = () => {
        // Count only visible (non-deleted) fields
        const visibleFieldCount = existingFormFields.filter(field => !field._deleted).length;
        const newFieldNumber = visibleFieldCount + 1;
        const newLabel = `Field ${newFieldNumber}`;
        const newField = {
            id: generateFieldId(newLabel, existingFormFields),
            fieldtypeId: "",
            fieldtype: "",
            fieldName: newLabel,
            isMandatory: false,
            isAddMore: 0,
            description: "",
            fieldValue: "",
            formType: "",
            radioCheckbox: [],
            radioCheckboxValue: '[]',
            isFieldSorting: visibleFieldCount,
            // Modern fields
            field_id: "",
            label: newLabel,
            field_type: "",
            required: false,
            placeholder: "",
            help_text: "",
            options: [],
            min_length: null,
            max_length: null,
            min_value: null,
            max_value: null,
            order: visibleFieldCount,
            // Additional field type specific properties
            allowOther: false,
            layout: 'column',
            labelOn: 'Yes',
            labelOff: 'No',
            accept: '*/*',
            maxSize: 5,
            maxQuantity: 1,
            sourceKey: '',
            valueMapping: '',
            labelMapping: '',
            debounce: 300
        };

        setExistingFormFields([...existingFormFields, newField]);
    };

    // Handle field type changes with confirmation
    const handleFieldTypeChangeWithConfirmation = (fieldIndex, e) => {
        const field = existingFormFields[fieldIndex];
        const currentFieldType = field.fieldtype || field.field_type;
        const isExistingField = field.field_id && field.field_id !== '';

        // Persist event data BEFORE async dialog (React recycles synthetic events)
        const eventData = {
            name: e.target.name,
            value: e.target.value,
            type: e.target.type,
            checked: e.target.checked
        };

        // If field type is not set yet (new field without type), allow change without confirmation
        if (!currentFieldType) {
            handleChange(fieldIndex, e);
            return;
        }

        // Get the new field type name for display
        const newFieldTypeId = eventData.value;
        const fieldTypeValue = formFieldTypeList.find(item => item.id == newFieldTypeId);
        const newFieldTypeName = fieldTypeValue ? (fieldTypeValue.name || fieldTypeValue.fieldType) : 'Unknown';

        // Show confirmation dialog
        const warningMessage = isExistingField
            ? `This field already exists in the database. Changing its type from "${currentFieldType}" to "${newFieldTypeName}" may cause data loss or reset its configuration. All field-specific settings (options, validations, etc.) will be reset to defaults.`
            : `Changing the field type from "${currentFieldType}" to "${newFieldTypeName}" will reset its configuration to defaults. All field-specific settings will be lost.`;

        Swal.fire({
            title: "Change Field Type?",
            text: warningMessage,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, change it",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                // User confirmed, proceed with the change
                // Create synthetic event object with persisted data
                const syntheticEvent = {
                    target: {
                        name: eventData.name,
                        value: eventData.value,
                        type: eventData.type,
                        checked: eventData.checked
                    }
                };
                handleChange(fieldIndex, syntheticEvent);

                // Show success message
                Swal.fire({
                    title: "Field Type Changed",
                    text: `Field type has been changed to "${newFieldTypeName}". Remember to click "Update Fields" to save your changes.`,
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false
                });
            } else {
                // User cancelled, reset the select to current value
                // The UI will automatically revert because we didn't update state
            }
        });
    };

    // Handle drag & drop reordering of fields
    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (!over || active.id === over.id) {
            return;
        }

        setExistingFormFields((fields) => {
            // Get only non-deleted fields for reordering
            const visibleFields = fields.filter(f => !f._deleted);
            const deletedFields = fields.filter(f => f._deleted);

            // Find indices in visible fields array
            const oldIndex = visibleFields.findIndex(f => (f.field_id || f.id) === active.id);
            const newIndex = visibleFields.findIndex(f => (f.field_id || f.id) === over.id);

            if (oldIndex === -1 || newIndex === -1) {
                return fields;
            }

            // Reorder visible fields
            const reorderedVisible = arrayMove(visibleFields, oldIndex, newIndex);

            // Update order property for all visible fields
            const updatedVisible = reorderedVisible.map((field, index) => ({
                ...field,
                order: index,
                isFieldSorting: index
            }));

            // Merge back with deleted fields (keep deleted at end)
            return [...updatedVisible, ...deletedFields];
        });

        toast.success('Field order updated');
    };

    const handleChange = useCallback((i, e) => {
        const { name, value, type, checked } = e.target;

        setExistingFormFields(prevFields => {
            const newFormValues = [...prevFields];

            if (name == "field_type") {
                // Handle field type changes with reactive UI updates (same as create form)
                let fieldTypeValue = formFieldTypeList.find((element) => {
                    return element.id == value;
                });

                const actualFieldType = fieldTypeValue ? (fieldTypeValue.fieldType || fieldTypeValue.name) : value;
                const config = FIELD_CONFIG_MAP[actualFieldType];

                if (config) {
                    // Preserve shared properties and apply new defaults
                    const sharedProps = {
                        label: newFormValues[i].label,
                        id: newFormValues[i].id,
                        fieldName: newFormValues[i].fieldName,
                        order: newFormValues[i].order,
                        help_text: newFormValues[i].help_text,
                        description: newFormValues[i].description,
                        required: newFormValues[i].required
                    };

                    // Merge existing validation with new defaults, preserving custom messages
                    const existingValidation = newFormValues[i].validation || {};
                    const newValidation = { ...config.defaults.validation };

                    // Only use new default messages for empty or default validation messages
                    Object.keys(newValidation).forEach(key => {
                        if (existingValidation[key] && existingValidation[key] !== '') {
                            // Keep existing custom validation message
                            newValidation[key] = existingValidation[key];
                        }
                    });

                    // Deep clone config.defaults to avoid shared references (especially for options array)
                    const clonedDefaults = JSON.parse(JSON.stringify(config.defaults));

                    newFormValues[i] = {
                        ...newFormValues[i],
                        ...clonedDefaults,
                        ...sharedProps,
                        validation: newValidation,
                        fieldtypeId: value,
                        fieldtype: actualFieldType,
                        field_type: actualFieldType
                    };
                } else {
                    newFormValues[i]["field_type"] = actualFieldType;
                    newFormValues[i]["fieldtype"] = actualFieldType;
                    newFormValues[i]["fieldtypeId"] = value;
                }

                // Clear field-specific errors when type changes
                setFieldErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[i];
                    return newErrors;
                });
            } else if (name == 'required') {
                newFormValues[i][name] = checked;
                newFormValues[i]['isMandatory'] = checked ? 1 : 0;
            } else if (name == 'label') {
                // Update label without regenerating ID (to prevent focus loss)
                // ID regeneration happens on blur instead via handleLabelBlur
                newFormValues[i][name] = value;
                newFormValues[i]['fieldName'] = value;
            } else if (type === 'checkbox') {
                newFormValues[i][name] = checked;
                if (name === 'required') {
                    newFormValues[i].isMandatory = checked ? 1 : 0; // Legacy compatibility
                }
            } else if (name.startsWith("validation.")) {
                // Handle validation message updates
                const validationKey = name.replace("validation.", "");
                if (!newFormValues[i].validation) {
                    newFormValues[i].validation = {};
                }
                newFormValues[i].validation[validationKey] = value;
            } else {
                newFormValues[i][name] = value;
                // Update legacy compatibility fields
                if (name === "field_type") {
                    newFormValues[i]["fieldtype"] = value;
                }
            }

            // Validate field and update errors
            const fieldErrors = validateField(newFormValues[i], i);
            setFieldErrors(prev => {
                const newErrors = { ...prev };
                if (Object.keys(fieldErrors).length > 0) {
                    newErrors[i] = fieldErrors;
                } else {
                    delete newErrors[i];
                }
                return newErrors;
            });

            // Recalculate formula fields that depend on this number field
            if ((newFormValues[i].field_type === 'number' || newFormValues[i].fieldtype === 'number') &&
                (name === 'default_value' || name === 'placeholder')) {
                const fieldId = newFormValues[i].label?.toLowerCase().replace(/[^a-z0-9]/g, '_') || newFormValues[i].fieldName;

                newFormValues.forEach((f, idx) => {
                    if (idx > i && (f.field_type === 'formula' || f.fieldtype === 'formula')) {
                        if (f.referenced_field_ids && f.referenced_field_ids.includes(fieldId)) {
                            calculateFormulaPreview(idx, newFormValues);
                        }
                    }
                });
            }

            return newFormValues;
        });
    }, [formFieldTypeList]);

    // Handle label blur - regenerate ID/name when user finishes editing
    const handleLabelBlur = useCallback((i, e) => {
        const value = e.target.value;
        if (!value || !value.trim()) return;

        setExistingFormFields(prevFields => {
            const newFormValues = [...prevFields];
            const newId = generateFieldId(value, newFormValues.filter((_, idx) => idx !== i));

            // Only update if ID actually changed (to avoid unnecessary re-renders)
            // For existing fields from backend, keep the original field_id but update the generated id/name
            if (newFormValues[i].id !== newId) {
                newFormValues[i].id = newId;
                newFormValues[i].name = newId;
                return newFormValues;
            }
            return prevFields; // Return unchanged if no update needed
        });
    }, []);

    // Remove field function - works for both existing and new fields
    const removeField = (field, fieldIndex) => {
        // Check if this would be the last field
        const currentVisibleFields = existingFormFields.filter(field => !field._deleted).length;

        if (currentVisibleFields <= 1) {
            Swal.fire({
                title: "Cannot delete field",
                text: "Form must have at least one field. Add another field before deleting this one.",
                icon: "error",
                confirmButtonText: "OK"
            });
            return; // Exit early, don't proceed with deletion
        }

        // Show confirmation dialog for all field deletions
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this field. Changes will be applied when you click 'Update Fields'.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it",
        }).then((result) => {
            if (result.isConfirmed) {
                const newFields = [...existingFormFields];

                if (field.field_id && field.field_id !== '') {
                    // This is an existing field from backend - mark as deleted
                    newFields[fieldIndex] = { ...field, _deleted: true };
                } else {
                    // This is a new field - remove completely from array
                    newFields.splice(fieldIndex, 1);
                }

                setExistingFormFields(newFields);

                // Remove any validation errors for this field
                setFieldErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[fieldIndex];

                    if (!(field.field_id && field.field_id !== '')) {
                        // For new fields that are completely removed, reindex errors
                        const reindexedErrors = {};
                        Object.keys(newErrors).forEach(key => {
                            const index = parseInt(key);
                            if (index > fieldIndex) {
                                reindexedErrors[index - 1] = newErrors[key];
                            } else if (index < fieldIndex) {
                                reindexedErrors[key] = newErrors[key];
                            }
                        });
                        return reindexedErrors;
                    }

                    return newErrors;
                });

            }
        });
    };

    let handleChangeForNewField = (i, e) => {
        let newFormValues = [...formValues];

        if (e.target.name == 'formId') {
            getFormFieldsListAPI(i, e.target.value);
        }

        if (e.target.name == 'field_type') {
            console.log('Field type selection changed:', e.target.value);
            console.log('Available field types:', formFieldTypeList);

            let fieldTypeValue = formFieldTypeList.find((element) => {
                return element.id == e.target.value;
            })

            if (fieldTypeValue) {
                console.log('Selected field type:', fieldTypeValue);
                newFormValues[i]['field_type'] = fieldTypeValue.fieldType || fieldTypeValue.name;
                newFormValues[i]['fieldtypeId'] = e.target.value;
                newFormValues[i]['fieldtype'] = fieldTypeValue.fieldType || fieldTypeValue.name;
            } else {
                console.error('Field type not found for ID:', e.target.value);
                console.log('Searching for ID in field types:', formFieldTypeList.map(ft => ({ id: ft.id, name: ft.name })));
                // Reset field type if not found
                newFormValues[i]['field_type'] = '';
                newFormValues[i]['fieldtypeId'] = '';
                newFormValues[i]['fieldtype'] = '';
            }
        } else if (e.target.name == 'required') {
            newFormValues[i][e.target.name] = e.target.checked;
            newFormValues[i]['isMandatory'] = e.target.checked ? 1 : 0;
        } else if (e.target.name == 'label') {
            newFormValues[i][e.target.name] = e.target.value;
            newFormValues[i]['fieldName'] = e.target.value;
        } else {
            newFormValues[i][e.target.name] = e.target.value;
        }
        setFormValues(newFormValues);
    }

    const handleAddFile = (i, e) => {
        let newFormValues = [...formValues];
        newFormValues[i]['filedValue'] = e.target.files[0];
        setFormValues(newFormValues);

    }

    let handleChangeRadio = (i, e) => {
        let newFormValues = [...formValues];
        radioFieldValueArr[i] = e.target.value
        newFormValues[rowIndex]['radioCheckbox'] = radioFieldValueArr
        setFormValues(newFormValues);
    }

    let handleChangeRadioForEdit = (indexOfRow, i, e, data) => {
        let radioFieldValueArr = JSON.parse(data);
        let newFormValues = [...existingFormFields];
        radioFieldValueArr[i] = e.target.value
        newFormValues[indexOfRow]['radioCheckbox'] = JSON.stringify(radioFieldValueArr)
        newFormValues[indexOfRow]['radioCheckboxValue'] = JSON.stringify(radioFieldValueArr)
        setExistingFormFields(newFormValues);
    }

    let addFormFields = () => {
        fieldArr.push([])
        radioFieldValueArr = []
        radioAddFieldArr[rowIndex + 1] = [{ radioCheckboxValue: "" }]
        setFormValues([...formValues, {
            field_id: "",
            label: "",
            field_type: "",
            required: false,
            placeholder: null,
            help_text: "",
            options: [],
            min_length: null,
            max_length: null,
            min_value: null,
            max_value: null,
            order: formValues.length,
            // Legacy compatibility fields
            fieldtypeId: "",
            fieldtype: "",
            fieldName: "",
            action: '',
            isMandatory: false,
            isAddMore: 0,
            description: '',
            filedValue: '',
            formType: '',
            radioCheckbox: []
        }])
        setRowIndex(rowIndex + 1);
    }

    let removeFormFields = (i) => {
        setRowIndex(rowIndex - 1);
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues)
    }

    let addRadioCheckboxFormFields = (index) => {
        radioAddFieldArr[index].push({ radioCheckboxValue: "" })
        setFormRadioCheckbox([...formRadioCheckbox, { radioCheckboxValue: "" }])
    }

    let addRadioCheckboxFormFieldsForEdit = (i, data) => {
        let radioFieldValueArr = JSON.parse(data);
        radioFieldValueArr.push("");
        let newFormValues = [...existingFormFields];
        newFormValues[i]['radioCheckbox'] = JSON.stringify(radioFieldValueArr)
        newFormValues[i]['radioCheckboxValue'] = JSON.stringify(radioFieldValueArr)
        setExistingFormFields(newFormValues);
    }

    let removeFormFieldsForEdit = (indexOfField, i, data) => {
        let radioFieldValueArr = JSON.parse(data);
        radioFieldValueArr.splice(indexOfField, 1);
        let newFormValues = [...existingFormFields];
        newFormValues[i]['radioCheckbox'] = JSON.stringify(radioFieldValueArr)
        newFormValues[i]['radioCheckboxValue'] = JSON.stringify(radioFieldValueArr)
        setExistingFormFields(newFormValues);
    }
    let handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error("Please fix validation errors");
            return;
        }
        try {
            let res = await updateWebFormAction(id, {
                name: formData.name,
                description: formData.description,
                department_id: formData.department_id,
                category_id: formData.category_id,
                is_active: formData.is_active,
                fields: formField
            }, currentFormVersion);
            if (res.success) {
                toast.success(res.message || "Form updated successfully");
                // Only refresh form data, not version info
                getFormFieldsData();
            } else {
                toast.error(res.message || "Failed to update form");
            }
        } catch (error) {
            console.error('Error updating form:', error);
            const status = error?.response?.status;
            if (status === 403) {
                toast.error(error?.response?.data?.detail || 'You do not have permission to update forms.');
                return;
            }
            toast.error("Failed to update form");
        }
    }

    // Function to filter validation messages based on field type and configuration
    const getRelevantValidationMessages = (field, fieldType) => {
        // Header fields should not have any validation (special case: backend may handle null differently for headers)
        if (fieldType === 'header') return null;

        if (!field.validation) return {};

        const validationMessages = {};

        // Always include required message if field is required
        if ((field.required || field.isMandatory === 1) && field.validation.required_message) {
            validationMessages.required_message = field.validation.required_message;
        }

        // Field type specific validation messages
        switch (fieldType) {
            case 'text':
            case 'textarea':
                if (field.min_length !== null && field.min_length !== undefined && field.validation.min_length_message) {
                    validationMessages.min_length_message = field.validation.min_length_message;
                }
                if (field.max_length !== null && field.max_length !== undefined && field.validation.max_length_message) {
                    validationMessages.max_length_message = field.validation.max_length_message;
                }
                if (field.validation.pattern && field.validation.pattern_message) {
                    validationMessages.pattern = field.validation.pattern;
                    validationMessages.pattern_message = field.validation.pattern_message;
                }
                break;

            case 'email':
                if (field.validation.invalid_email_message) {
                    validationMessages.invalid_email_message = field.validation.invalid_email_message;
                }
                if (field.validation.pattern && field.validation.pattern_message) {
                    validationMessages.pattern = field.validation.pattern;
                    validationMessages.pattern_message = field.validation.pattern_message;
                }
                break;

            case 'phone':
                if (field.validation.invalid_phone_message) {
                    validationMessages.invalid_phone_message = field.validation.invalid_phone_message;
                }
                if (field.validation.pattern && field.validation.pattern_message) {
                    validationMessages.pattern = field.validation.pattern;
                    validationMessages.pattern_message = field.validation.pattern_message;
                }
                break;

            case 'url':
                if (field.validation.invalid_url_message) {
                    validationMessages.invalid_url_message = field.validation.invalid_url_message;
                }
                break;

            case 'number':
                if (field.min_value !== null && field.min_value !== undefined && field.validation.min_value_message) {
                    validationMessages.min_value_message = field.validation.min_value_message;
                }
                if (field.max_value !== null && field.max_value !== undefined && field.validation.max_value_message) {
                    validationMessages.max_value_message = field.validation.max_value_message;
                }
                if (field.validation.invalid_number_message) {
                    validationMessages.invalid_number_message = field.validation.invalid_number_message;
                }
                if (field.validation.pattern && field.validation.pattern_message) {
                    validationMessages.pattern = field.validation.pattern;
                    validationMessages.pattern_message = field.validation.pattern_message;
                }
                break;

            case 'date':
                if (field.min_value !== null && field.min_value !== undefined && field.validation.min_date_message) {
                    validationMessages.min_date_message = field.validation.min_date_message;
                }
                if (field.max_value !== null && field.max_value !== undefined && field.validation.max_date_message) {
                    validationMessages.max_date_message = field.validation.max_date_message;
                }
                if (field.validation.invalid_date_message) {
                    validationMessages.invalid_date_message = field.validation.invalid_date_message;
                }
                break;

            case 'time':
                if (field.min_value !== null && field.min_value !== undefined && field.validation.min_time_message) {
                    validationMessages.min_time_message = field.validation.min_time_message;
                }
                if (field.max_value !== null && field.max_value !== undefined && field.validation.max_time_message) {
                    validationMessages.max_time_message = field.validation.max_time_message;
                }
                if (field.validation.invalid_time_message) {
                    validationMessages.invalid_time_message = field.validation.invalid_time_message;
                }
                break;

            case 'datetime':
                if (field.min_value !== null && field.min_value !== undefined && field.validation.min_datetime_message) {
                    validationMessages.min_datetime_message = field.validation.min_datetime_message;
                }
                if (field.max_value !== null && field.max_value !== undefined && field.validation.max_datetime_message) {
                    validationMessages.max_datetime_message = field.validation.max_datetime_message;
                }
                if (field.validation.invalid_datetime_message) {
                    validationMessages.invalid_datetime_message = field.validation.invalid_datetime_message;
                }
                break;

            case 'file_upload':
            case 'file':
                if (field.validation.invalid_file_type_message) {
                    validationMessages.invalid_file_type_message = field.validation.invalid_file_type_message;
                }
                if (field.validation.file_too_large_message) {
                    validationMessages.file_too_large_message = field.validation.file_too_large_message;
                }
                if (field.validation.too_many_files_message) {
                    validationMessages.too_many_files_message = field.validation.too_many_files_message;
                }
                break;

            case 'dropdown':
            case 'select_manual':
            case 'multiselect':
            case 'radio':
            case 'checkboxes':
            case 'checkbox':
                // Choice fields typically only need required message
                break;

            case 'lookup':
                if (field.validation.no_results_message) {
                    validationMessages.no_results_message = field.validation.no_results_message;
                }
                break;

            case 'toggle':
                // Toggle only needs required message (already handled above)
                break;

            case 'signature':
                // Signature only needs required message (already handled above)
                break;

            case 'formula':
                if (field.validation.invalid_formula_message) {
                    validationMessages.invalid_formula_message = field.validation.invalid_formula_message;
                }
                if (field.validation.missing_field_message) {
                    validationMessages.missing_field_message = field.validation.missing_field_message;
                }
                if (field.validation.division_by_zero_message) {
                    validationMessages.division_by_zero_message = field.validation.division_by_zero_message;
                }
                break;

            default:
                // For unknown field types, include pattern validation if present
                if (field.validation.pattern && field.validation.pattern_message) {
                    validationMessages.pattern = field.validation.pattern;
                    validationMessages.pattern_message = field.validation.pattern_message;
                }
                break;
        }

        // Return empty object if no validation messages are relevant (backend expects dictionary, not null)
        return Object.keys(validationMessages).length > 0 ? validationMessages : {};
    };

    // Formula field helper functions
    const insertFieldIntoFormula = (fieldIndex, fieldId) => {
        const newFields = [...existingFormFields];
        const currentExpression = newFields[fieldIndex].formula_expression || '';
        const newExpression = currentExpression + (currentExpression ? ' ' : '') + fieldId;
        newFields[fieldIndex].formula_expression = newExpression;
        validateAndUpdateFormula(fieldIndex, newExpression, newFields);
        setExistingFormFields(newFields);
    };

    const insertOperatorIntoFormula = (fieldIndex, operator) => {
        const newFields = [...existingFormFields];
        const currentExpression = newFields[fieldIndex].formula_expression || '';
        const needsSpace = currentExpression && ![' ', '('].some(char => currentExpression.endsWith(char));
        const newExpression = currentExpression + (needsSpace ? ' ' : '') + operator + (operator === '(' ? '' : ' ');
        newFields[fieldIndex].formula_expression = newExpression;
        validateAndUpdateFormula(fieldIndex, newExpression, newFields);
        setExistingFormFields(newFields);
    };

    const handleFormulaChange = (fieldIndex, event) => {
        const newFields = [...existingFormFields];
        const newExpression = event.target.value;
        newFields[fieldIndex].formula_expression = newExpression;
        validateAndUpdateFormula(fieldIndex, newExpression, newFields);
        setExistingFormFields(newFields);
    };

    const validateAndUpdateFormula = (fieldIndex, expression, fieldsCopy) => {
        // Validate syntax
        const syntaxValidation = validateFormulaSyntax(expression);
        if (!syntaxValidation.valid) {
            fieldsCopy[fieldIndex].formula_error = syntaxValidation.error;
            fieldsCopy[fieldIndex].referenced_field_ids = [];
            fieldsCopy[fieldIndex].calculated_value = null;
            return;
        }

        // Parse referenced fields
        const referencedFields = parseFormulaFields(expression);
        fieldsCopy[fieldIndex].referenced_field_ids = referencedFields;

        // Validate field references - allow referencing any number field in the form
        const validReferences = referencedFields.every(refId => {
            const field = fieldsCopy.find(f => {
                const fieldId = f.label?.toLowerCase().replace(/[^a-z0-9]/g, '_') || f.fieldName || f.id;
                return fieldId === refId && (f.field_type === 'number' || f.fieldtype === 'number');
            });
            return field !== undefined;
        });

        if (!validReferences) {
            fieldsCopy[fieldIndex].formula_error = 'One or more referenced fields do not exist or are not number fields';
            fieldsCopy[fieldIndex].calculated_value = null;
            return;
        }

        // Check for circular dependencies
        const allDependencies = {};
        fieldsCopy.forEach((field, idx) => {
            if ((field.field_type === 'formula' || field.fieldtype === 'formula') && field.referenced_field_ids) {
                allDependencies[idx] = field.referenced_field_ids;
            }
        });

        if (detectCircularDependency(fieldIndex, referencedFields, allDependencies)) {
            fieldsCopy[fieldIndex].formula_error = 'Circular dependency detected';
            fieldsCopy[fieldIndex].calculated_value = null;
            return;
        }

        // Clear errors and calculate preview
        fieldsCopy[fieldIndex].formula_error = null;
        calculateFormulaPreview(fieldIndex, fieldsCopy);
    };

    const calculateFormulaPreview = (fieldIndex, fieldsCopy) => {
        const formulaField = fieldsCopy[fieldIndex];
        const expression = formulaField.formula_expression;
        const referencedFields = formulaField.referenced_field_ids || [];

        if (!expression || referencedFields.length === 0) {
            fieldsCopy[fieldIndex].calculated_value = null;
            return;
        }

        // Build field values from default values - only use explicit defaults
        const fieldValues = {};
        let hasAllDefaults = true;

        referencedFields.forEach(refId => {
            const refField = fieldsCopy.find(f => {
                const fieldId = f.label?.toLowerCase().replace(/[^a-z0-9]/g, '_') || f.fieldName || f.id;
                return fieldId === refId && (f.field_type === 'number' || f.fieldtype === 'number');
            });

            if (refField) {
                // Check for explicit default value or placeholder (but don't fallback to 0)
                const defaultVal = refField.default_value || refField.default || refField.placeholder;
                if (defaultVal !== null && defaultVal !== undefined && defaultVal !== '') {
                    const parsedValue = parseFloat(defaultVal);
                    if (!isNaN(parsedValue)) {
                        fieldValues[refId] = parsedValue;
                    } else {
                        hasAllDefaults = false;
                    }
                } else {
                    hasAllDefaults = false;
                }
            } else {
                hasAllDefaults = false;
            }
        });

        // Only calculate if all referenced fields have explicit defaults
        if (hasAllDefaults && Object.keys(fieldValues).length > 0) {
            const result = evaluateFormula(expression, fieldValues);
            if (result.success) {
                const decimalPlaces = formulaField.decimal_places ?? 2;
                fieldsCopy[fieldIndex].calculated_value = parseFloat(result.value.toFixed(decimalPlaces));
            } else {
                fieldsCopy[fieldIndex].calculated_value = null;
                fieldsCopy[fieldIndex].formula_error = result.error;
            }
        } else {
            // Skip calculation if any field lacks a default value
            fieldsCopy[fieldIndex].calculated_value = null;
        }
    };

    let updateFormFileds = async (event) => {
        event.preventDefault();

        // Validate all fields before submission
        const validationResult = validateAllFields(existingFormFields);

        if (validationResult.hasErrors) {
            // Update the fieldErrors state with all validation errors
            setFieldErrors(validationResult.errors);

            // Show first error to user
            const firstFieldWithError = Object.keys(validationResult.errors)[0];
            const firstError = Object.values(validationResult.errors[firstFieldWithError])[0];
            toast.error(`Field ${parseInt(firstFieldWithError) + 1}: ${firstError}`);

            // Scroll to first field with error
            const firstErrorElement = document.querySelector(`[data-field-index="${firstFieldWithError}"]`);
            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            return;
        }

        // Check if there are any existing validation errors
        const hasValidationErrors = Object.keys(fieldErrors).length > 0;

        if (hasValidationErrors) {
            // Show first error to user
            const firstFieldWithError = Object.keys(fieldErrors)[0];
            const firstError = Object.values(fieldErrors[firstFieldWithError])[0];
            toast.error(`Field ${parseInt(firstFieldWithError) + 1}: ${firstError}`);
            return;
        }

        try {
            // Prepare form data in backend format

            const updateData = {
                name: formData.name,
                description: formData.description,
                department_id: formData.department_id,
                category_id: formData.category_id,
                is_active: formData.is_active,
                version: formData.version,
                fields: existingFormFields
                    .filter(field => !field._deleted) // Exclude deleted fields
                    .filter(field => {
                        // Only include fields that have a field_id (from backend) or proper field_type
                        return (field.field_id && field.field_id !== '') ||
                            (field.field_type && field.field_type !== '' && field.label && field.label.trim() !== '');
                    })
                    .map((field, index) => {
                        // Handle options for choice fields
                        let optionStrings = [];
                        if (field.options && Array.isArray(field.options)) {
                            optionStrings = field.options.map((option) => {
                                if (typeof option === 'string') return option;
                                if (option && typeof option === 'object') {
                                    return option.label || option.value || option.radioCheckboxValue || '';
                                }
                                return String(option);
                            }).filter(Boolean);
                        } else if (field.radioCheckbox && Array.isArray(field.radioCheckbox)) {
                            // Legacy support
                            optionStrings = field.radioCheckbox.filter(Boolean);
                        }

                        // Debug logging for formula fields
                        const fieldType = field.field_type || field.fieldtype || 'text';
                        const isFormula = fieldType === 'formula' || field.field_type === 'formula' || field.fieldtype === 'formula';
                        if (isFormula) {
                            console.log(`Processing formula field ${index}:`, {
                                field_id: field.id,
                                label: field.label || field.fieldName,
                                field_type: fieldType,
                                formula_expression: field.formula_expression,
                                referenced_field_ids: field.referenced_field_ids,
                                decimal_places: field.decimal_places,
                                prefix: field.prefix,
                                suffix: field.suffix,
                                show_formula: field.show_formula,
                                willIncludeInPayload: fieldType === 'formula' || field.field_type === 'formula' || field.fieldtype === 'formula'
                            });
                        }

                        return {
                            field_id: field.id,
                            label: field.label || field.fieldName || '',
                            field_type: field.field_type || field.fieldtype || 'text',
                            required: Boolean(field.required) || field.isMandatory === 1,
                            placeholder: field.placeholder || null,
                            help_text: field.help_text || field.description || '',
                            options: optionStrings,
                            min_length: field.min_length && field.min_length !== "" ? parseInt(field.min_length, 10) : null,
                            max_length: field.max_length && field.max_length !== "" ? parseInt(field.max_length, 10) : null,
                            min_value: field.min_value && field.min_value !== "" ? parseFloat(field.min_value) : null,
                            max_value: field.max_value && field.max_value !== "" ? parseFloat(field.max_value) : null,
                            step: field.step ?? null,
                            order: field.order || 0,
                            // Formula-specific properties (only included if field_type is 'formula')
                            ...((field.field_type === 'formula' || field.fieldtype === 'formula') && {
                                formula_expression: field.formula_expression || '',
                                referenced_field_ids: field.referenced_field_ids || [],
                                decimal_places: field.decimal_places ?? 2,
                                prefix: field.prefix || '',
                                suffix: field.suffix || '',
                                show_formula: Boolean(field.show_formula),
                                calculated_value: field.calculated_value ?? null,
                            }),
                            // Validation configuration - only include relevant validation messages
                            validation: getRelevantValidationMessages(field, field.field_type || field.fieldtype || 'text'),
                            // Additional field type specific properties
                            allowOther: field.allowOther,
                            layout: field.layout,
                            labelOn: field.labelOn,
                            labelOff: field.labelOff,
                            accept: field.accept,
                            maxSize: field.maxSize,
                            maxQuantity: field.maxQuantity,
                            sourceKey: field.sourceKey,
                            valueMapping: field.valueMapping,
                            labelMapping: field.labelMapping,
                            debounce: field.debounce,
                            // Legacy compatibility
                            field_name: field.fieldName || null,
                            is_mandatory: field.isMandatory || 0,
                            is_add_more: field.isAddMore || 0,
                            field_description: field.description || null,
                            form_type: field.formType || null,
                            dropdown_form_id: field.dropdown_form_id || null,
                            dropdown_field_id: field.dropdown_field_id || null,
                            master_data_table: field.master_data_table || null,
                            master_data_column: field.master_data_column || null,
                            selected_form_id: field.selected_form_id || null,
                            selected_other_fields: field.selected_other_fields || []
                        };
                    })
            };

            // Debug logging for final data
            console.log('Final form data being sent (updateFormFileds):', JSON.stringify(updateData, null, 2));

            let res = await updateWebFormAction(id, updateData);
            if (res.success) {
                toast.success(res.message || res.msg || "Form updated successfully");
                // Navigate to listing page
                setTimeout(() => {
                    navigate('/webforms');
                }, 1500);
            } else {
                // Handle validation errors or other error objects
                const errorMessage = res.message || res.msg || res.error || "Failed to update form";
                if (typeof errorMessage === 'string') {
                    toast.error(errorMessage);
                } else if (Array.isArray(errorMessage)) {
                    errorMessage.forEach(err => {
                        if (typeof err === 'string') {
                            toast.error(err);
                        } else if (err && typeof err === 'object' && err.msg) {
                            toast.error(err.msg);
                        }
                    });
                } else {
                    toast.error("Failed to update form");
                }
            }
        } catch (error) {
            const errorMessage = error.message || error.msg || "Failed to update form";
            if (typeof errorMessage === 'string') {
                toast.error(errorMessage);
            } else {
                toast.error("Failed to update form");
            }
        }
    }

    // NOTE: deleteFields function is no longer used
    // All field deletions now work through local state management in removeField
    // Fields are marked with _deleted: true and filtered out during form update

    return (
        <>
            <Dashboardheader />
            {/* <ToastContainer /> */}
            <div className="wrapper">
                <Sidebar />
                <div id="content">
                    <Container fluid className="p-4">
                        {/* Modern Header Section */}
                        <Row>
                            <Col lg={12} md={12} sm={12} className="mb-4">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h3 className="mb-1 text-dark fw-bold d-flex align-items-center gap-2">
                                            <MdEdit className="text-primary" size={24} />
                                            Edit Form Fields
                                        </h3>
                                        <p className="text-muted mb-0">Modify fields and settings for this healthcare form</p>
                                    </div>
                                    <Link
                                        to={`${config.baseUrl}webforms`}
                                        className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
                                    >
                                        <BsArrowLeft size={16} />
                                        Back to Forms
                                    </Link>
                                </div>
                            </Col>
                        </Row>

                        {/* Version selection UI removed. Version is controlled by parent route. */}

                        {/* Form Information Card */}
                        {formData.name && (
                            <Row>
                                <Col lg={12} md={12} sm={12} className="mb-4">
                                    <Card className="border-0 shadow-sm bg-info bg-opacity-10">
                                        <Card.Body className="py-3">
                                            <div className="d-flex align-items-center gap-2">
                                                <MdInfo className="text-info" size={20} />
                                                <div>
                                                    <h6 className="mb-1 fw-semibold text-dark">
                                                        {formData.name}
                                                    </h6>
                                                    <div className="d-flex gap-3 small text-muted">
                                                        <span>
                                                            <strong>Department:</strong> {departmentList.length > 0 ? getDepartmentName(formData.department_id) : 'Loading...'}
                                                        </span>
                                                        <span>
                                                            <strong>Category:</strong> {formCategoryList.length > 0 ? getCategoryName(formData.category_id) : 'Loading...'}
                                                        </span>
                                                        <span>
                                                            <strong>Form ID:</strong> {formNumber || 'Loading...'}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        )}

                        {/* Form Details Section */}
                        <Row>
                            <Col lg={12} md={12} sm={12} className="mb-4">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-primary bg-opacity-10 border-0">
                                        <h6 className="mb-0 fw-semibold text-dark d-flex align-items-center gap-2">
                                            <MdEdit className="text-primary" size={20} />
                                            Form Details
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <Row className="g-3">
                                            <Col lg={6} md={6} sm={12}>
                                                <label className="form-label text-sm fw-medium text-dark">
                                                    Form Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    onChange={handleChangeForm}
                                                    name='name'
                                                    value={formData?.name || ''}
                                                    placeholder="Enter form name..."
                                                    aria-label="Form name"
                                                    required
                                                />
                                            </Col>

                                            <Col lg={6} md={6} sm={12}>
                                                <label className="form-label text-sm fw-medium text-dark">
                                                    Form Number
                                                </label>
                                                <input
                                                    className='form-control bg-light'
                                                    type="text"
                                                    readOnly
                                                    value={formNumber || ''}
                                                    aria-label="Auto-generated form number"
                                                />
                                                <small className="text-muted">Auto-generated unique identifier</small>
                                            </Col>

                                            <Col lg={6} md={6} sm={12}>
                                                <label className="form-label text-sm fw-medium text-dark">
                                                    Department <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className='form-select'
                                                    name='department_id'
                                                    onChange={handleChangeForm}
                                                    value={formData?.department_id || ''}
                                                    aria-label="Select department"
                                                    required
                                                >
                                                    <option value="">Choose department...</option>
                                                    {departmentList.map(data => {
                                                        const departmentId = data.department_id || data.id || data.name;
                                                        const departmentName = data.name || data.department_name || 'Unknown';
                                                        return (
                                                            <option key={departmentId} value={departmentId}>
                                                                {departmentName}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </Col>

                                            <Col lg={6} md={6} sm={12}>
                                                <label className="form-label text-sm fw-medium text-dark">
                                                    Description
                                                </label>
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    name='description'
                                                    onChange={handleChangeForm}
                                                    value={formData?.description || ''}
                                                    placeholder="Enter form description..."
                                                    aria-label="Form description"
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {/* Form Settings Section */}
                        <Row>
                            <Col lg={12} md={12} sm={12} className="mb-4">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-success bg-opacity-10 border-0">
                                        <h6 className="mb-0 fw-semibold text-dark d-flex align-items-center gap-2">
                                            <MdSave className="text-success" size={20} />
                                            Form Settings
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <Row className="g-3">
                                            <Col lg={6} md={6} sm={12}>
                                                <label className="form-label text-sm fw-medium text-dark">
                                                    Form Category <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    name="category_id"
                                                    onChange={handleChangeForm}
                                                    value={formData?.category_id || ''}
                                                    aria-label="Select form category"
                                                    required
                                                >
                                                    <option value="">Choose category...</option>
                                                    {formCategoryList.map(data => {
                                                        const categoryId = data.category_id || data.id || data.name;
                                                        const categoryName = data.name || data.category_name || 'Unknown';
                                                        return (
                                                            <option key={categoryId} value={categoryId}>{categoryName}</option>
                                                        );
                                                    })}
                                                </select>
                                            </Col>

                                            {/* Late Entry Access - Future feature implementation
                                            <Col lg={3} md={3} sm={12}>
                                                <label className="form-label text-sm fw-medium text-dark">
                                                    Late Entry Access
                                                </label>
                                                <div className="d-flex align-items-center gap-3 mt-2">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="isLateEntry"
                                                            value="0"
                                                            id="lateEntryNoEdit"
                                                            onChange={handleChangeForm}
                                                            checked={formData?.isLateEntry == 0 || !formData?.isLateEntry}
                                                        />
                                                        <label className="form-check-label" htmlFor="lateEntryNoEdit">
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="isLateEntry"
                                                            value="1"
                                                            id="lateEntryYesEdit"
                                                            onChange={handleChangeForm}
                                                            checked={formData?.isLateEntry == 1}
                                                        />
                                                        <label className="form-check-label" htmlFor="lateEntryYesEdit">
                                                            Yes
                                                        </label>
                                                    </div>
                                                </div>
                                            </Col>

                                            {formData?.isLateEntry == 1 && (
                                                <Col lg={3} md={3} sm={12}>
                                                    <label className="form-label text-sm fw-medium text-dark">
                                                        Late Entry Time (Hours)
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        name="lateEntryTime"
                                                        value={formData?.lateEntryTime || ''}
                                                        onChange={handleChangeForm}
                                                        placeholder="24"
                                                        min="1"
                                                        max="168"
                                                        aria-label="Late entry time in hours"
                                                    />
                                                    <small className="text-muted">Maximum 7 days (168 hours)</small>
                                                </Col>
                                            )}
                                            */}
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {/* Existing Fields Section */}
                        <Row>
                            <Col lg={12} md={12} sm={12} className="mb-4">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-warning bg-opacity-10 border-0">
                                        <h6 className="mb-0 fw-semibold text-dark d-flex align-items-center gap-2">
                                            <MdVisibility className="text-warning" size={20} />
                                            Existing Form Fields
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="enhanced-fields-editor">
                                            <form onSubmit={updateFormFileds}>
                                                {existingFormFields.length > 0 ? (
                                                    <DndContext
                                                        sensors={sensors}
                                                        collisionDetection={closestCenter}
                                                        onDragEnd={handleDragEnd}
                                                    >
                                                        <SortableContext
                                                            items={existingFormFields
                                                                .filter(f => !f._deleted)
                                                                .map(f => f.field_id || f.id)}
                                                            strategy={verticalListSortingStrategy}
                                                        >
                                                            {existingFormFields
                                                                .map((element, originalIndex) => {
                                                                    // Skip deleted fields
                                                                    if (element._deleted) return null;

                                                                    // Calculate display index (1-based numbering for non-deleted fields)
                                                                    const displayIndex = existingFormFields
                                                                        .slice(0, originalIndex)
                                                                        .filter(f => !f._deleted).length + 1;

                                                                    const config = FIELD_CONFIG_MAP[element.field_type];
                                                                    const currentFieldErrors = fieldErrors[originalIndex] || {};
                                                                    const hasErrors = Object.keys(currentFieldErrors).length > 0;
                                                                    const fieldId = element.field_id || element.id;

                                                                    return (
                                                                        <SortableFieldItem key={fieldId} id={fieldId}>
                                                                            {(dragHandleProps) => (
                                                                                <div data-field-index={originalIndex} className={`mb-4 p-3 border rounded-3 ${hasErrors ? 'border-danger bg-danger bg-opacity-10' : 'bg-light bg-opacity-50'}`}>
                                                                                    {/* Field Header */}
                                                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                        <h6 className="mb-0 fw-semibold text-dark d-flex align-items-center gap-2">
                                                                                            {/* Drag Handle */}
                                                                                            <span
                                                                                                {...dragHandleProps}
                                                                                                style={{
                                                                                                    cursor: 'grab',
                                                                                                    display: 'flex',
                                                                                                    alignItems: 'center',
                                                                                                    padding: '4px'
                                                                                                }}
                                                                                                title="Drag to reorder"
                                                                                            >
                                                                                                <MdDragIndicator size={20} className="text-secondary" />
                                                                                            </span>
                                                                                            <span className="badge bg-secondary me-2">{displayIndex}</span>
                                                                                            {element.label || element.fieldName || 'Untitled Field'}
                                                                                            <Badge bg="info" className="text-white ms-2">
                                                                                                {element?.fieldtype || element?.field_type || 'Unknown'}
                                                                                            </Badge>
                                                                                        </h6>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-outline-danger btn-sm"
                                                                                            onClick={() => removeField(element, originalIndex)}
                                                                                            title="Delete field"
                                                                                        >
                                                                                            <BsFillTrash3Fill size={14} />
                                                                                        </button>
                                                                                    </div>

                                                                                    {/* Error Display */}
                                                                                    {hasErrors && (
                                                                                        <div className="alert alert-danger alert-sm mb-3">
                                                                                            <small>
                                                                                                <strong>Validation Errors:</strong>
                                                                                                <ul className="mb-0 mt-1">
                                                                                                    {Object.entries(currentFieldErrors).map(([key, error]) => (
                                                                                                        <li key={key}>{error}</li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </small>
                                                                                        </div>
                                                                                    )}

                                                                                    {/* Basic Field Configuration */}
                                                                                    <div className="row mb-3">
                                                                                        {/* Field Type - Editable for all fields */}
                                                                                        <div className="col-md-4 mb-2">
                                                                                            <label className="form-label small fw-medium text-dark">Field Type <span className="text-danger">*</span></label>
                                                                                            <select
                                                                                                name="field_type"
                                                                                                className={`form-select ${currentFieldErrors.field_type ? 'is-invalid' : ''}`}
                                                                                                value={getFieldTypeIdForDisplay(element, formFieldTypeList)}
                                                                                                onChange={(e) => handleFieldTypeChangeWithConfirmation(originalIndex, e)}
                                                                                            >
                                                                                                <option value="">Choose type...</option>
                                                                                                {Array.isArray(formFieldTypeList) && formFieldTypeList.map((item) => (
                                                                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>

                                                                                        {/* Field Label */}
                                                                                        <div className="col-md-4 mb-2">
                                                                                            <label className="form-label small fw-medium text-dark">Field Label <span className="text-danger">*</span></label>
                                                                                            <input
                                                                                                type="text"
                                                                                                className={`form-control ${currentFieldErrors.label ? 'is-invalid' : ''}`}
                                                                                                name="label"
                                                                                                value={element.label || element.fieldName || ""}
                                                                                                onChange={e => handleChange(originalIndex, e)}
                                                                                                onBlur={(e) => handleLabelBlur(originalIndex, e)}
                                                                                                placeholder="Enter field name..."
                                                                                            />
                                                                                        </div>

                                                                                        {/* Required Checkbox - Hidden for header fields */}
                                                                                        {(element.field_type !== 'header' && element.fieldtype !== 'header') && (
                                                                                            <div className="col-md-4 mb-2 d-flex align-items-end">
                                                                                                <div className="form-check">
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        className="form-check-input"
                                                                                                        name="required"
                                                                                                        id={`existing_required_${originalIndex}`}
                                                                                                        checked={element.required || element.isMandatory ? true : false}
                                                                                                        onChange={e => handleChange(originalIndex, e)}
                                                                                                    />
                                                                                                    <label className="form-check-label" htmlFor={`existing_required_${originalIndex}`}>
                                                                                                        Required field
                                                                                                    </label>
                                                                                                    <small className="text-muted d-block">
                                                                                                        Check to configure validation messages
                                                                                                    </small>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>

                                                                                    {/* Help Text */}
                                                                                    <div className="row mb-3">
                                                                                        <div className="col-12">
                                                                                            <label className="form-label small fw-medium text-dark">Help Text</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                name="help_text"
                                                                                                value={element.help_text || element.description || ""}
                                                                                                onChange={(e) => handleChange(originalIndex, e)}
                                                                                                placeholder="Optional help text for users..."
                                                                                            />
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Field Type Specific Controls */}
                                                                                    {config && element.field_type && (
                                                                                        <div className="field-type-controls">
                                                                                            <h6 className="small fw-semibold text-muted mb-2">Field Type Settings</h6>

                                                                                            {/* Options Editor for Choice Fields */}
                                                                                            {config.needsOptions && (
                                                                                                <div className="options-editor mb-3">
                                                                                                    {/* Master Data Configuration */}
                                                                                                    <Card className="mb-3">
                                                                                                        <Card.Header className="py-2">
                                                                                                            <Form.Check
                                                                                                                type="switch"
                                                                                                                id={`use-master-data-${originalIndex}`}
                                                                                                                label="Use Master Data"
                                                                                                                checked={element.useMasterData || false}
                                                                                                                onChange={(e) => toggleMasterData(e, originalIndex)}
                                                                                                            />
                                                                                                        </Card.Header>

                                                                                                        {element.useMasterData && (
                                                                                                            <Card.Body className="p-3">
                                                                                                                {/* Master Data Table Selection */}
                                                                                                                <Form.Group className="mb-3">
                                                                                                                    <Form.Label className="small fw-medium">
                                                                                                                        Master Data Table <span className="text-danger">*</span>
                                                                                                                    </Form.Label>
                                                                                                                    <Select
                                                                                                                        options={masterDataTables}
                                                                                                                        value={masterDataTables.find(t => t.value === element.master_data_table)}
                                                                                                                        onChange={(selected) => handleMasterTableChange(selected, originalIndex)}
                                                                                                                        placeholder="Select master data table..."
                                                                                                                        isClearable
                                                                                                                        isSearchable
                                                                                                                    />
                                                                                                                    <Form.Text className="text-muted">
                                                                                                                        Choose the master data table to populate options from
                                                                                                                    </Form.Text>
                                                                                                                </Form.Group>

                                                                                                                {/* Master Data Column Selection */}
                                                                                                                {element.master_data_table && (
                                                                                                                    <Form.Group className="mb-3">
                                                                                                                        <Form.Label className="small fw-medium">
                                                                                                                            Display Column <span className="text-danger">*</span>
                                                                                                                        </Form.Label>
                                                                                                                        <Select
                                                                                                                            options={masterDataColumns[element.master_data_table] || []}
                                                                                                                            value={masterDataColumns[element.master_data_table]?.find(
                                                                                                                                c => c.value === element.master_data_column
                                                                                                                            )}
                                                                                                                            onChange={(selected) => handleMasterColumnChange(selected, originalIndex)}
                                                                                                                            placeholder="Select column to display..."
                                                                                                                            isClearable
                                                                                                                            isSearchable
                                                                                                                        />
                                                                                                                        <Form.Text className="text-muted">
                                                                                                                            Choose which column values to show in the dropdown
                                                                                                                        </Form.Text>
                                                                                                                    </Form.Group>
                                                                                                                )}

                                                                                                                {/* Preview Options Button */}
                                                                                                                {element.master_data_table && element.master_data_column && (
                                                                                                                    <Button
                                                                                                                        variant="outline-primary"
                                                                                                                        size="sm"
                                                                                                                        onClick={() => previewMasterDataOptions(originalIndex)}
                                                                                                                    >
                                                                                                                        Preview Options ({element.masterDataPreviewCount || 0} items)
                                                                                                                    </Button>
                                                                                                                )}
                                                                                                            </Card.Body>
                                                                                                        )}
                                                                                                    </Card>

                                                                                                    {/* Static Options Configuration - Only show if not using master data */}
                                                                                                    {!element.useMasterData && (
                                                                                                        <>
                                                                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                                                                <label className="form-label small fw-medium text-dark mb-0">
                                                                                                                    Options <span className="text-danger">*</span>
                                                                                                                </label>
                                                                                                                <button
                                                                                                                    type="button"
                                                                                                                    className="btn btn-outline-primary btn-sm"
                                                                                                                    onClick={() => addOptionToExisting(originalIndex)}
                                                                                                                >
                                                                                                                    <BsFilePlusFill size={12} className="me-1" />Add Option
                                                                                                                </button>
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )}

                                                                                                    {/* Options List - Only show if not using master data */}
                                                                                                    {!element.useMasterData && (
                                                                                                        <div>
                                                                                                    {element.options && element.options.length > 0 ? (
                                                                                                        <div className="options-list">
                                                                                                            {element.options.map((option, optionIndex) => (
                                                                                                                <div key={optionIndex} className="mb-3">
                                                                                                                    <div className="d-flex align-items-center gap-2 p-2 border rounded">
                                                                                                                        <span className="badge bg-secondary">{optionIndex + 1}</span>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            placeholder="Option label..."
                                                                                                                            value={option.label || ""}
                                                                                                                            onChange={(e) => updateOptionInExisting(originalIndex, optionIndex, 'label', e.target.value)}
                                                                                                                        />
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            placeholder="Option value..."
                                                                                                                            value={option.value || ""}
                                                                                                                            onChange={(e) => updateOptionInExisting(originalIndex, optionIndex, 'value', e.target.value)}
                                                                                                                        />

                                                                                                                        {/* Image upload button */}
                                                                                                                        <label
                                                                                                                            className={`btn btn-sm ${option.imageUrl ? 'btn-success' : 'btn-outline-secondary'}`}
                                                                                                                            title="Add image option"
                                                                                                                            style={{cursor: 'pointer', whiteSpace: 'nowrap'}}
                                                                                                                        >
                                                                                                                            📷
                                                                                                                            <input
                                                                                                                                type="file"
                                                                                                                                accept="image/*"
                                                                                                                                hidden
                                                                                                                                onChange={(e) => {
                                                                                                                                    if (e.target.files[0]) {
                                                                                                                                        uploadOptionImage(e.target.files[0], originalIndex, optionIndex);
                                                                                                                                    }
                                                                                                                                }}
                                                                                                                            />
                                                                                                                        </label>

                                                                                                                        <div className="btn-group">
                                                                                                                            <button
                                                                                                                                type="button"
                                                                                                                                className="btn btn-outline-secondary btn-sm"
                                                                                                                                onClick={() => moveOptionInExisting(originalIndex, optionIndex, 'up')}
                                                                                                                                disabled={optionIndex === 0}
                                                                                                                                title="Move up"
                                                                                                                            >
                                                                                                                                ↑
                                                                                                                            </button>
                                                                                                                            <button
                                                                                                                                type="button"
                                                                                                                                className="btn btn-outline-secondary btn-sm"
                                                                                                                                onClick={() => moveOptionInExisting(originalIndex, optionIndex, 'down')}
                                                                                                                                disabled={optionIndex === element.options.length - 1}
                                                                                                                                title="Move down"
                                                                                                                            >
                                                                                                                                ↓
                                                                                                                            </button>
                                                                                                                        </div>
                                                                                                                        <button
                                                                                                                            type="button"
                                                                                                                            className="btn btn-outline-danger btn-sm"
                                                                                                                            onClick={() => removeOptionFromExisting(originalIndex, optionIndex)}
                                                                                                                            disabled={element.options.length <= 1}
                                                                                                                            title="Remove option"
                                                                                                                        >
                                                                                                                            <BsFillTrash3Fill size={12} />
                                                                                                                        </button>
                                                                                                                    </div>

                                                                                                                    {/* Image preview thumbnail */}
                                                                                                                    {option.imageUrl && (
                                                                                                                        <div className="mt-2 ms-5 d-flex align-items-center gap-2 p-2 bg-light border rounded">
                                                                                                                            <img
                                                                                                                                src={option.imageUrl}
                                                                                                                                alt={option.label}
                                                                                                                                style={{
                                                                                                                                    width: '60px',
                                                                                                                                    height: '60px',
                                                                                                                                    objectFit: 'cover',
                                                                                                                                    borderRadius: '4px',
                                                                                                                                    border: '1px solid #dee2e6'
                                                                                                                                }}
                                                                                                                            />
                                                                                                                            <span className="small text-muted flex-grow-1">Image attached</span>
                                                                                                                            <button
                                                                                                                                type="button"
                                                                                                                                className="btn btn-sm btn-outline-danger"
                                                                                                                                onClick={() => removeOptionImage(originalIndex, optionIndex)}
                                                                                                                                title="Remove image"
                                                                                                                            >
                                                                                                                                Remove Image
                                                                                                                            </button>
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        <div className="text-muted small text-center py-2 border rounded">
                                                                                                            No options found. Click "Add Option" to add some.
                                                                                                        </div>
                                                                                                    )}
                                                                                                    {currentFieldErrors.options && (
                                                                                                        <div className="text-danger small mt-1">{currentFieldErrors.options}</div>
                                                                                                    )}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}

                                                                                            {/* Additional Field Controls */}
                                                                                            {(element.field_type === 'text' || element.field_type === 'textarea') && (
                                                                                                <div className="row mb-2">
                                                                                                    <div className="col-md-4">
                                                                                                        <label className="form-label small fw-medium text-dark">Placeholder</label>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="placeholder"
                                                                                                            value={element.placeholder || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            placeholder="Enter placeholder text..."
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="col-md-4">
                                                                                                        <label className="form-label small fw-medium text-dark">Min Length</label>
                                                                                                        <input
                                                                                                            type="number"
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="min_length"
                                                                                                            value={element.min_length || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            min="0"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="col-md-4">
                                                                                                        <label className="form-label small fw-medium text-dark">Max Length</label>
                                                                                                        <input
                                                                                                            type="number"
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="max_length"
                                                                                                            value={element.max_length || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            min="1"
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* Number Field Controls */}
                                                                                            {element.field_type === 'number' && (
                                                                                                <div className="row mb-2">
                                                                                                    <div className="col-md-4">
                                                                                                        <label className="form-label small fw-medium text-dark">Min Value</label>
                                                                                                        <input
                                                                                                            type="number"
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="min_value"
                                                                                                            value={element.min_value || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            step="any"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="col-md-4">
                                                                                                        <label className="form-label small fw-medium text-dark">Max Value</label>
                                                                                                        <input
                                                                                                            type="number"
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="max_value"
                                                                                                            value={element.max_value || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            step="any"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="col-md-4">
                                                                                                        <label className="form-label small fw-medium text-dark">Step</label>
                                                                                                        <input
                                                                                                            type="number"
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="step"
                                                                                                            value={element.step || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            step="any"
                                                                                                            placeholder="1"
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* Markdown Field Controls */}
                                                                                            {element.field_type === 'markdown' && (
                                                                                                <div className="row mb-3">
                                                                                                    <div className="col-12">
                                                                                                        <Form.Group className="mb-3">
                                                                                                            <Form.Label className="small fw-medium text-dark">
                                                                                                                Markdown Content
                                                                                                            </Form.Label>
                                                                                                            <Form.Control
                                                                                                                as="textarea"
                                                                                                                rows={10}
                                                                                                                name="label"
                                                                                                                value={element.label || ''}
                                                                                                                onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                placeholder="# Heading&#10;&#10;Your **markdown** content here..."
                                                                                                                style={{ fontFamily: 'monospace', fontSize: '14px' }}
                                                                                                            />
                                                                                                            <Form.Text className="text-muted d-block mb-2">
                                                                                                                Supports: **bold**, *italic*, # headings, - lists, [links](url),
                                                                                                                tables, task lists, and more.
                                                                                                            </Form.Text>

                                                                                                            {/* Live Preview */}
                                                                                                            <div className="mt-3">
                                                                                                                <strong className="small fw-medium text-dark">Preview:</strong>
                                                                                                                <div
                                                                                                                    className="border rounded p-3 mt-2 markdown-preview"
                                                                                                                    style={{ backgroundColor: '#f8f9fa', minHeight: '100px' }}
                                                                                                                >
                                                                                                                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                                                                                                        {element.label || '*No content*'}
                                                                                                                    </ReactMarkdown>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </Form.Group>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* Date/Time Field Controls */}
                                                                                            {(element.field_type === 'date' || element.field_type === 'time' || element.field_type === 'datetime') && (
                                                                                                <div className="row mb-2">
                                                                                                    <div className="col-md-6">
                                                                                                        <label className="form-label small fw-medium text-dark">Min {element.field_type}</label>
                                                                                                        <input
                                                                                                            type={element.field_type}
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="min_value"
                                                                                                            value={element.min_value || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="col-md-6">
                                                                                                        <label className="form-label small fw-medium text-dark">Max {element.field_type}</label>
                                                                                                        <input
                                                                                                            type={element.field_type}
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="max_value"
                                                                                                            value={element.max_value || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* Radio/Checkbox Layout Controls */}
                                                                                            {(element.field_type === 'radio' || element.field_type === 'checkbox') && (
                                                                                                <div className="row mb-2">
                                                                                                    <div className="col-md-6">
                                                                                                        <label className="form-label small fw-medium text-dark">Layout</label>
                                                                                                        <select
                                                                                                            className="form-select form-select-sm"
                                                                                                            name="layout"
                                                                                                            value={element.layout || 'column'}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                        >
                                                                                                            <option value="column">Vertical (Column)</option>
                                                                                                            <option value="row">Horizontal (Row)</option>
                                                                                                        </select>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* File Upload Controls */}
                                                                                            {element.field_type === 'file' && (
                                                                                                <div className="row mb-2">
                                                                                                    <div className="col-md-4">
                                                                                                        <label className="form-label small fw-medium text-dark">Accept Types</label>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="accept"
                                                                                                            value={element.accept || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            placeholder="e.g., .pdf,.doc,.jpg"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="col-md-4">
                                                                                                        <label className="form-label small fw-medium text-dark">Max Size (MB)</label>
                                                                                                        <input
                                                                                                            type="number"
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="maxSize"
                                                                                                            value={element.maxSize || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            min="1"
                                                                                                            max="100"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="col-md-4">
                                                                                                        <label className="form-label small fw-medium text-dark">Max Quantity</label>
                                                                                                        <input
                                                                                                            type="number"
                                                                                                            className="form-control form-control-sm"
                                                                                                            name="maxQuantity"
                                                                                                            value={element.maxQuantity || ""}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            min="1"
                                                                                                            max="10"
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* Formula Field Configuration */}
                                                                                            {(element.field_type === 'formula' || element.fieldtype === 'formula') && (
                                                                                                <div className="formula-field-config">
                                                                                                    <h6 className="text-muted mb-3">Formula Builder</h6>

                                                                                                    {/* Field Picker Dropdown */}
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label className="small text-muted">Insert Field</Form.Label>
                                                                                                        <Form.Select
                                                                                                            size="sm"
                                                                                                            onChange={(e) => {
                                                                                                                if (e.target.value) {
                                                                                                                    insertFieldIntoFormula(originalIndex, e.target.value);
                                                                                                                    e.target.value = ''; // Reset dropdown
                                                                                                                }
                                                                                                            }}
                                                                                                        >
                                                                                                            <option value="">-- Select a number field --</option>
                                                                                                            {existingFormFields
                                                                                                                .map((field, idx) => {
                                                                                                                    // Show all number fields except the current formula field
                                                                                                                    if ((field.field_type === 'number' || field.fieldtype === 'number') && idx !== originalIndex) {
                                                                                                                        const fieldId = field.label?.toLowerCase().replace(/[^a-z0-9]/g, '_') || field.fieldName || field.id || `field_${idx}`;
                                                                                                                        return (
                                                                                                                            <option key={field.id || idx} value={fieldId}>
                                                                                                                                {field.label || field.fieldName || `Field ${idx + 1}`}
                                                                                                                            </option>
                                                                                                                        );
                                                                                                                    }
                                                                                                                    return null;
                                                                                                                })}
                                                                                                        </Form.Select>
                                                                                                    </Form.Group>

                                                                                                    {/* Operator Buttons */}
                                                                                                    <div className="btn-group btn-group-sm mb-3" role="group">
                                                                                                        <button type="button" className="btn btn-outline-secondary"
                                                                                                                onClick={() => insertOperatorIntoFormula(originalIndex, '+')}>+</button>
                                                                                                        <button type="button" className="btn btn-outline-secondary"
                                                                                                                onClick={() => insertOperatorIntoFormula(originalIndex, '-')}>-</button>
                                                                                                        <button type="button" className="btn btn-outline-secondary"
                                                                                                                onClick={() => insertOperatorIntoFormula(originalIndex, '*')}>×</button>
                                                                                                        <button type="button" className="btn btn-outline-secondary"
                                                                                                                onClick={() => insertOperatorIntoFormula(originalIndex, '/')}>/</button>
                                                                                                        <button type="button" className="btn btn-outline-secondary"
                                                                                                                onClick={() => insertOperatorIntoFormula(originalIndex, '^')}
                                                                                                                title="Power/Exponent (e.g., x^2)">
                                                                                                            x<sup>y</sup>
                                                                                                        </button>
                                                                                                        <button type="button" className="btn btn-outline-secondary"
                                                                                                                onClick={() => insertOperatorIntoFormula(originalIndex, '(')}>(</button>
                                                                                                        <button type="button" className="btn btn-outline-secondary"
                                                                                                                onClick={() => insertOperatorIntoFormula(originalIndex, ')')}>)</button>
                                                                                                    </div>

                                                                                                    {/* Formula Expression Input */}
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label className="small">Formula Expression</Form.Label>
                                                                                                        <Form.Control
                                                                                                            type="text"
                                                                                                            size="sm"
                                                                                                            className={element.formula_error ? 'is-invalid' : ''}
                                                                                                            name="formula_expression"
                                                                                                            value={element.formula_expression || ""}
                                                                                                            onChange={(e) => handleFormulaChange(originalIndex, e)}
                                                                                                            placeholder="e.g., weight / height ^ 2 (for BMI)"
                                                                                                        />
                                                                                                        {element.formula_error && (
                                                                                                            <div className="invalid-feedback d-block">{element.formula_error}</div>
                                                                                                        )}
                                                                                                    </Form.Group>

                                                                                                    {/* Referenced Fields Display */}
                                                                                                    {element.referenced_field_ids && element.referenced_field_ids.length > 0 && (
                                                                                                        <div className="alert alert-info py-2 px-3 mb-3">
                                                                                                            <small>
                                                                                                                <strong>Referenced fields:</strong>{' '}
                                                                                                                {element.referenced_field_ids.join(', ')}
                                                                                                            </small>
                                                                                                        </div>
                                                                                                    )}

                                                                                                    {/* Preview Calculation */}
                                                                                                    {element.calculated_value !== null && element.calculated_value !== undefined && (
                                                                                                        <div className="alert alert-success py-2 px-3 mb-3">
                                                                                                            <small>
                                                                                                                <strong>Preview:</strong>{' '}
                                                                                                                {element.prefix}{element.calculated_value}{element.suffix}
                                                                                                            </small>
                                                                                                        </div>
                                                                                                    )}

                                                                                                    {/* Decimal Places */}
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label className="small">Decimal Places</Form.Label>
                                                                                                        <Form.Control
                                                                                                            type="number"
                                                                                                            size="sm"
                                                                                                            name="decimal_places"
                                                                                                            value={element.decimal_places ?? 2}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            min="0"
                                                                                                            max="10"
                                                                                                        />
                                                                                                    </Form.Group>

                                                                                                    {/* Prefix */}
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label className="small">Prefix</Form.Label>
                                                                                                        <Form.Control
                                                                                                            type="text"
                                                                                                            size="sm"
                                                                                                            name="prefix"
                                                                                                            value={element.prefix || ''}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            placeholder="e.g., $"
                                                                                                        />
                                                                                                    </Form.Group>

                                                                                                    {/* Suffix */}
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Label className="small">Suffix</Form.Label>
                                                                                                        <Form.Control
                                                                                                            type="text"
                                                                                                            size="sm"
                                                                                                            name="suffix"
                                                                                                            value={element.suffix || ''}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                            placeholder="e.g., kg/m²"
                                                                                                        />
                                                                                                    </Form.Group>

                                                                                                    {/* Show Formula Checkbox */}
                                                                                                    <Form.Group className="mb-3">
                                                                                                        <Form.Check
                                                                                                            type="checkbox"
                                                                                                            id={`show-formula-${originalIndex}`}
                                                                                                            label="Show formula to users"
                                                                                                            name="show_formula"
                                                                                                            checked={element.show_formula || false}
                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                        />
                                                                                                        <Form.Text className="text-muted">
                                                                                                            If enabled, the formula expression will be displayed to users below the calculated value
                                                                                                        </Form.Text>
                                                                                                    </Form.Group>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* Validation Messages Configuration */}
                                                                                            {config && element.validation && element.required && (
                                                                                                <div className="validation-messages mb-3 fade-in">
                                                                                                    <h6 className="small fw-semibold text-muted mb-2 d-flex align-items-center gap-2">
                                                                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-primary">
                                                                                                            <path d="M9 12l2 2 4-4"></path>
                                                                                                            <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"></path>
                                                                                                            <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"></path>
                                                                                                        </svg>
                                                                                                        Validation Messages
                                                                                                    </h6>
                                                                                                    <div className="border rounded p-3 bg-light bg-opacity-50" style={{ transition: 'all 0.3s ease-in-out' }}>

                                                                                                        {/* Required Message */}
                                                                                                        {config.controls.includes('required') && (
                                                                                                            <div className="row mb-2">
                                                                                                                <div className="col-12">
                                                                                                                    <label className="form-label small fw-medium text-dark">Required Field Message</label>
                                                                                                                    <input
                                                                                                                        type="text"
                                                                                                                        className="form-control form-control-sm"
                                                                                                                        name="validation.required_message"
                                                                                                                        value={element.validation?.required_message || ""}
                                                                                                                        onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                        placeholder="This field is required"
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}

                                                                                                        {/* Text Length Messages */}
                                                                                                        {(element.field_type === 'text' || element.field_type === 'textarea') && (
                                                                                                            <>
                                                                                                                <div className="row mb-2">
                                                                                                                    <div className="col-md-6">
                                                                                                                        <label className="form-label small fw-medium text-dark">Min Length Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.min_length_message"
                                                                                                                            value={element.validation?.min_length_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Text is too short"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                    <div className="col-md-6">
                                                                                                                        <label className="form-label small fw-medium text-dark">Max Length Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.max_length_message"
                                                                                                                            value={element.validation?.max_length_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Text is too long"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                {/* Pattern Validation for Text Fields */}
                                                                                                                <div className="row mb-2">
                                                                                                                    <div className="col-md-6">
                                                                                                                        <label className="form-label small fw-medium text-dark">Custom Pattern (RegEx)</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.pattern"
                                                                                                                            value={element.validation?.pattern || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="^[A-Za-z0-9]+$"
                                                                                                                        />
                                                                                                                        <small className="text-muted">E.g., ^[A-Za-z0-9]+$ for alphanumeric text</small>
                                                                                                                    </div>
                                                                                                                    <div className="col-md-6">
                                                                                                                        <label className="form-label small fw-medium text-dark">Pattern Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.pattern_message"
                                                                                                                            value={element.validation?.pattern_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Please enter a valid format"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </>
                                                                                                        )}

                                                                                                        {/* Number Validation Messages */}
                                                                                                        {element.field_type === 'number' && (
                                                                                                            <>
                                                                                                                <div className="row mb-2">
                                                                                                                    <div className="col-md-4">
                                                                                                                        <label className="form-label small fw-medium text-dark">Min Value Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.min_value_message"
                                                                                                                            value={element.validation?.min_value_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Number is too small"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                    <div className="col-md-4">
                                                                                                                        <label className="form-label small fw-medium text-dark">Max Value Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.max_value_message"
                                                                                                                            value={element.validation?.max_value_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Number is too large"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                    <div className="col-md-4">
                                                                                                                        <label className="form-label small fw-medium text-dark">Invalid Number Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.invalid_number_message"
                                                                                                                            value={element.validation?.invalid_number_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Please enter a valid number"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                {/* Custom Pattern Validation for Number Fields */}
                                                                                                                <div className="row mb-2">
                                                                                                                    <div className="col-md-6">
                                                                                                                        <label className="form-label small fw-medium text-dark">Custom Pattern (RegEx)</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.pattern"
                                                                                                                            value={element.validation?.pattern || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="^\d{1,10}(\.\d{1,2})?$"
                                                                                                                        />
                                                                                                                        <small className="text-muted">E.g., ^\d{"{1,10}"}(\.\d{"{1,2}"})? for decimal numbers</small>
                                                                                                                    </div>
                                                                                                                    <div className="col-md-6">
                                                                                                                        <label className="form-label small fw-medium text-dark">Pattern Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.pattern_message"
                                                                                                                            value={element.validation?.pattern_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Please enter a valid number format"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </>
                                                                                                        )}

                                                                                                        {/* Email Validation Message */}
                                                                                                        {element.field_type === 'email' && (
                                                                                                            <div className="row mb-2">
                                                                                                                <div className="col-12">
                                                                                                                    <label className="form-label small fw-medium text-dark">Invalid Email Message</label>
                                                                                                                    <input
                                                                                                                        type="text"
                                                                                                                        className="form-control form-control-sm"
                                                                                                                        name="validation.invalid_email_message"
                                                                                                                        value={element.validation?.invalid_email_message || ""}
                                                                                                                        onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                        placeholder="Please enter a valid email address"
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}

                                                                                                        {/* Phone Validation Message */}
                                                                                                        {element.field_type === 'phone' && (
                                                                                                            <>
                                                                                                                <div className="row mb-2">
                                                                                                                    <div className="col-12">
                                                                                                                        <label className="form-label small fw-medium text-dark">Invalid Phone Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.invalid_phone_message"
                                                                                                                            value={element.validation?.invalid_phone_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Please enter a valid phone number"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                {/* Custom Pattern Validation for Phone Fields */}
                                                                                                                <div className="row mb-2">
                                                                                                                    <div className="col-md-6">
                                                                                                                        <label className="form-label small fw-medium text-dark">Custom Pattern (RegEx)</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.pattern"
                                                                                                                            value={element.validation?.pattern || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="^\+?[1-9]\d{1,14}$"
                                                                                                                        />
                                                                                                                        <small className="text-muted">E.g., ^\+?[1-9]\d{"{1,14}"} for international format</small>
                                                                                                                    </div>
                                                                                                                    <div className="col-md-6">
                                                                                                                        <label className="form-label small fw-medium text-dark">Pattern Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.pattern_message"
                                                                                                                            value={element.validation?.pattern_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Please enter a valid phone format"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </>
                                                                                                        )}

                                                                                                        {/* URL Validation Message */}
                                                                                                        {element.field_type === 'url' && (
                                                                                                            <div className="row mb-2">
                                                                                                                <div className="col-12">
                                                                                                                    <label className="form-label small fw-medium text-dark">Invalid URL Message</label>
                                                                                                                    <input
                                                                                                                        type="text"
                                                                                                                        className="form-control form-control-sm"
                                                                                                                        name="validation.invalid_url_message"
                                                                                                                        value={element.validation?.invalid_url_message || ""}
                                                                                                                        onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                        placeholder="Please enter a valid URL"
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}

                                                                                                        {/* Date/Time Validation Messages */}
                                                                                                        {(element.field_type === 'date' || element.field_type === 'time' || element.field_type === 'datetime') && (
                                                                                                            <div className="row mb-2">
                                                                                                                <div className="col-md-4">
                                                                                                                    <label className="form-label small fw-medium text-dark">Min {element.field_type} Message</label>
                                                                                                                    <input
                                                                                                                        type="text"
                                                                                                                        className="form-control form-control-sm"
                                                                                                                        name={`validation.min_${element.field_type}_message`}
                                                                                                                        value={element.validation?.[`min_${element.field_type}_message`] || ""}
                                                                                                                        onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                        placeholder={`${element.field_type} is too early`}
                                                                                                                    />
                                                                                                                </div>
                                                                                                                <div className="col-md-4">
                                                                                                                    <label className="form-label small fw-medium text-dark">Max {element.field_type} Message</label>
                                                                                                                    <input
                                                                                                                        type="text"
                                                                                                                        className="form-control form-control-sm"
                                                                                                                        name={`validation.max_${element.field_type}_message`}
                                                                                                                        value={element.validation?.[`max_${element.field_type}_message`] || ""}
                                                                                                                        onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                        placeholder={`${element.field_type} is too late`}
                                                                                                                    />
                                                                                                                </div>
                                                                                                                <div className="col-md-4">
                                                                                                                    <label className="form-label small fw-medium text-dark">Invalid {element.field_type} Message</label>
                                                                                                                    <input
                                                                                                                        type="text"
                                                                                                                        className="form-control form-control-sm"
                                                                                                                        name={`validation.invalid_${element.field_type}_message`}
                                                                                                                        value={element.validation?.[`invalid_${element.field_type}_message`] || ""}
                                                                                                                        onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                        placeholder={`Please enter a valid ${element.field_type}`}
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}

                                                                                                        {/* File Upload Validation Messages */}
                                                                                                        {element.field_type === 'file' && (
                                                                                                            <>
                                                                                                                {/* Required Message for File Upload */}
                                                                                                                <div className="row mb-2">
                                                                                                                    <div className="col-12">
                                                                                                                        <label className="form-label small fw-medium text-dark">Required File Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.required_message"
                                                                                                                            value={element.validation?.required_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Please select a file"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className="row mb-2">
                                                                                                                    <div className="col-md-6">
                                                                                                                        <label className="form-label small fw-medium text-dark">Invalid File Type Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.invalid_file_type_message"
                                                                                                                            value={element.validation?.invalid_file_type_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="File type not allowed"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                    <div className="col-md-6">
                                                                                                                        <label className="form-label small fw-medium text-dark">File Too Large Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.file_too_large_message"
                                                                                                                            value={element.validation?.file_too_large_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="File size exceeds limit"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="row mb-2">
                                                                                                                    <div className="col-12">
                                                                                                                        <label className="form-label small fw-medium text-dark">Too Many Files Message</label>
                                                                                                                        <input
                                                                                                                            type="text"
                                                                                                                            className="form-control form-control-sm"
                                                                                                                            name="validation.too_many_files_message"
                                                                                                                            value={element.validation?.too_many_files_message || ""}
                                                                                                                            onChange={(e) => handleChange(originalIndex, e)}
                                                                                                                            placeholder="Too many files selected"
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </SortableFieldItem>
                                                                    );
                                                                })}
                                                        </SortableContext>
                                                    </DndContext>
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <div className="text-muted">
                                                            <MdVisibility size={48} className="mb-3 opacity-50" />
                                                            <h6>No existing fields</h6>
                                                            <p className="mb-0">Click "Add Field" below to create your first field.</p>
                                                        </div>
                                                    </div>
                                                )}

                                                    {/* Update Button */}
                                                    <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                                                        <div>
                                                            <small className="text-muted">
                                                                Total fields: {existingFormFields.filter(field => !field._deleted).length}
                                                                {Object.keys(fieldErrors).length > 0 && (
                                                                    <span className="text-danger ms-2">
                                                                        • {Object.keys(fieldErrors).length} field(s) with errors
                                                                    </span>
                                                                )}
                                                            </small>
                                                        </div>
                                                        <div className="d-flex gap-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-primary btn-sm"
                                                                onClick={() => addNewField()}
                                                            >
                                                                <BsFilePlusFill size={16} className="me-1" />
                                                                Add Field
                                                            </button>
                                                            <button
                                                                type="submit"
                                                                className={`btn btn-sm ${Object.keys(fieldErrors).length > 0
                                                                    ? 'btn-outline-danger'
                                                                    : 'btn-success'
                                                                    }`}
                                                                disabled={Object.keys(fieldErrors).length > 0}
                                                            >
                                                                <MdSave size={16} className="me-1" />
                                                                Update Fields
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {existingFormFields.length > 0 ?
                            <Row>
                                <h5 className=''>Form Preview</h5>
                                <Col lg={12} md={12} sm={12} className="">
                                    <div className='formDiv'>
                                        <Form>
                                            <Row className="mb-4">
                                                {existingFormFields
                                                    .filter(field => !field._deleted)
                                                    .map((field, fieldIndex) => {
                                                        if (!field.label && !field.fieldName) return null;

                                                        // Get options from multiple possible sources
                                                        const getFieldOptions = (field) => {
                                                            // For single checkbox fields, never return options
                                                            if (field.field_type === 'checkbox' || field.fieldtype === 'checkbox') {
                                                                return [];
                                                            }

                                                            if (field.options && Array.isArray(field.options)) {
                                                                return field.options;
                                                            }
                                                            if (field.radioCheckbox) {
                                                                if (Array.isArray(field.radioCheckbox)) {
                                                                    return field.radioCheckbox;
                                                                }
                                                                if (typeof field.radioCheckbox === 'string') {
                                                                    try {
                                                                        return JSON.parse(field.radioCheckbox);
                                                                    } catch (e) {
                                                                        return [];
                                                                    }
                                                                }
                                                            }
                                                            if (field.radioCheckboxValue) {
                                                                try {
                                                                    return JSON.parse(field.radioCheckboxValue);
                                                                } catch (e) {
                                                                    return [];
                                                                }
                                                            }
                                                            return [];
                                                        };

                                                        const fieldOptions = getFieldOptions(field);

                                                        return (
                                                            <div key={fieldIndex} className='col-md-6 mt-2'>
                                                                <Form.Group>
                                                                    <Form.Label>
                                                                        {field.label || field.fieldName}
                                                                        {(field.required || field.isMandatory) && <span className="text-danger ms-1">*</span>}
                                                                    </Form.Label>

                                                                    {/* Dropdown/Select fields */}
                                                                    {(field.field_type === "dropdown" || field.fieldtype === "dropdown" ||
                                                                        field.field_type === "select" || field.fieldtype === "select" ||
                                                                        field.field_type === "select_manual" || field.fieldtype === "select_manual" ||
                                                                        field.field_type === "selectManual" || field.fieldtype === "selectManual") ? (
                                                                        <>
                                                                            <select className="form-select" disabled>
                                                                                <option>Choose option...</option>
                                                                                {fieldOptions.map((option, optionIndex) => (
                                                                                    <option key={optionIndex} value={option.value || option}>
                                                                                        {typeof option === 'string' ? option : (option.label || 'Option')}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                            {/* Show validation preview for required dropdown */}
                                                                            {field.required && field.validation?.required_message && (
                                                                                <div className="validation-preview mt-1">
                                                                                    <small className="text-danger d-block">
                                                                                        <strong>Validation:</strong> {field.validation.required_message}
                                                                                    </small>
                                                                                </div>
                                                                            )}
                                                                        </>

                                                                    ) : /* Multi-select fields */
                                                                        (field.field_type === "multiselect" || field.fieldtype === "multiselect") ? (
                                                                            <select className="form-select" multiple disabled>
                                                                                {fieldOptions.map((option, optionIndex) => (
                                                                                    <option key={optionIndex} value={option.value || option}>
                                                                                        {typeof option === 'string' ? option : (option.label || 'Option')}
                                                                                    </option>
                                                                                ))}
                                                                            </select>

                                                                        ) : /* Textarea fields */
                                                                            (field.field_type === "textarea" || field.fieldtype === "textarea") ? (
                                                                                <>
                                                                                    <textarea
                                                                                        className="form-control"
                                                                                        rows={field.rows || 3}
                                                                                        placeholder={field.placeholder || "Enter text..."}
                                                                                        disabled
                                                                                        minLength={field.min_length}
                                                                                        maxLength={field.max_length}
                                                                                    />
                                                                                    {/* Show validation preview for required textarea */}
                                                                                    {field.required && field.validation?.required_message && (
                                                                                        <div className="validation-preview mt-1">
                                                                                            <small className="text-danger d-block">
                                                                                                <strong>Validation:</strong> {field.validation.required_message}
                                                                                            </small>
                                                                                        </div>
                                                                                    )}
                                                                                    {/* Show text length validation */}
                                                                                    {(field.min_length || field.max_length) && (
                                                                                        <div className="input-validation-preview mt-1">
                                                                                            <small className="text-info d-block">
                                                                                                <strong>Length:</strong>
                                                                                                {field.min_length && ` Min ${field.min_length} chars`}
                                                                                                {field.min_length && field.max_length && `,`}
                                                                                                {field.max_length && ` Max ${field.max_length} chars`}
                                                                                            </small>
                                                                                            {field.validation?.min_length_message && field.min_length && (
                                                                                                <small className="text-danger d-block">
                                                                                                    <strong>Min Length:</strong> {field.validation.min_length_message}
                                                                                                </small>
                                                                                            )}
                                                                                            {field.validation?.max_length_message && field.max_length && (
                                                                                                <small className="text-danger d-block">
                                                                                                    <strong>Max Length:</strong> {field.validation.max_length_message}
                                                                                                </small>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                    {/* Show pattern validation */}
                                                                                    {field.validation?.pattern && (
                                                                                        <div className="pattern-preview mt-1">
                                                                                            <small className="text-warning d-block">
                                                                                                <strong>Pattern:</strong> {field.validation.pattern}
                                                                                            </small>
                                                                                            {field.validation?.pattern_message && (
                                                                                                <small className="text-danger d-block">
                                                                                                    <strong>Pattern Validation:</strong> {field.validation.pattern_message}
                                                                                                </small>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                </>

                                                                            ) : /* Paragraph fields */
                                                                            (field.field_type === "paragraph" || field.fieldtype === "paragraph") ? (
                                                                                <>
                                                                                    <textarea
                                                                                        className="form-control"
                                                                                        rows={field.rows || 5}
                                                                                        placeholder={field.placeholder || "Enter text..."}
                                                                                        disabled
                                                                                        minLength={field.min_length}
                                                                                        maxLength={field.max_length}
                                                                                    />
                                                                                    {/* Show validation preview for required paragraph */}
                                                                                    {field.required && field.validation?.required_message && (
                                                                                        <div className="validation-preview mt-1">
                                                                                            <small className="text-danger d-block">
                                                                                                <strong>Validation:</strong> {field.validation.required_message}
                                                                                            </small>
                                                                                        </div>
                                                                                    )}
                                                                                    {/* Show text length validation */}
                                                                                    {(field.min_length || field.max_length) && (
                                                                                        <div className="input-validation-preview mt-1">
                                                                                            <small className="text-info d-block">
                                                                                                <strong>Length:</strong>
                                                                                                {field.min_length && ` Min ${field.min_length} chars`}
                                                                                                {field.min_length && field.max_length && `,`}
                                                                                                {field.max_length && ` Max ${field.max_length} chars`}
                                                                                            </small>
                                                                                            {field.validation?.min_length_message && field.min_length && (
                                                                                                <small className="text-danger d-block">
                                                                                                    <strong>Min Length:</strong> {field.validation.min_length_message}
                                                                                                </small>
                                                                                            )}
                                                                                            {field.validation?.max_length_message && field.max_length && (
                                                                                                <small className="text-danger d-block">
                                                                                                    <strong>Max Length:</strong> {field.validation.max_length_message}
                                                                                                </small>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                    {/* Show pattern validation */}
                                                                                    {field.validation?.pattern && (
                                                                                        <div className="pattern-preview mt-1">
                                                                                            <small className="text-warning d-block">
                                                                                                <strong>Pattern:</strong> {field.validation.pattern}
                                                                                            </small>
                                                                                            {field.validation?.pattern_message && (
                                                                                                <small className="text-danger d-block">
                                                                                                    <strong>Pattern Validation:</strong> {field.validation.pattern_message}
                                                                                                </small>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                </>

                                                                            ) : /* File upload fields */
                                                                                (field.field_type === "file" || field.fieldtype === "file" ||
                                                                                    field.field_type === "file_upload" || field.fieldtype === "file_upload" ||
                                                                                    field.field_type === "image" || field.fieldtype === "image") ? (
                                                                                    <>
                                                                                        <input
                                                                                            type="file"
                                                                                            className="form-control"
                                                                                            accept={field.accept || "*/*"}
                                                                                            disabled
                                                                                        />
                                                                                        {/* Show validation preview for required file upload fields */}
                                                                                        {field.required && field.validation?.required_message && (
                                                                                            <div className="validation-preview mt-1">
                                                                                                <small className="text-danger d-block">
                                                                                                    <strong>Validation:</strong> {field.validation.required_message}
                                                                                                </small>
                                                                                            </div>
                                                                                        )}
                                                                                    </>

                                                                                ) : /* Radio button fields */
                                                                                    (field.field_type === "radio" || field.fieldtype === "radio") && fieldOptions.length > 0 ? (
                                                                                        <div className={`mt-2 ${field.layout === 'row' ? 'd-flex gap-3' : ''}`}>
                                                                                            {fieldOptions.map((option, optionIndex) => {
                                                                                                // Normalize option to object format if it's a string
                                                                                                const optionData = typeof option === 'string'
                                                                                                    ? { label: option, value: option, imageUrl: null }
                                                                                                    : option;

                                                                                                return (
                                                                                                    <div key={optionIndex} className="form-check">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            className="form-check-input"
                                                                                                            name={`radio-preview-${fieldIndex}`}
                                                                                                            disabled
                                                                                                        />
                                                                                                        <label className="form-check-label d-flex align-items-start gap-2">
                                                                                                            <span>{String(optionData.label || 'Option')}</span>
                                                                                                            {optionData.imageUrl && (
                                                                                                                <ImageOptionPreview
                                                                                                                    imageUrl={optionData.imageUrl}
                                                                                                                    label={optionData.label}
                                                                                                                />
                                                                                                            )}
                                                                                                        </label>
                                                                                                    </div>
                                                                                                );
                                                                                            })}
                                                                                        </div>

                                                                                    ) : /* Checkbox field - Single policy acceptance checkbox ONLY */
                                                                                        (field.field_type === "checkbox" || field.fieldtype === "checkbox") ? (
                                                                                            <div className="form-check">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="form-check-input"
                                                                                                    disabled
                                                                                                />
                                                                                                <label className="form-check-label">
                                                                                                    {field.placeholder || `I agree to ${(field.label || field.fieldName || 'the terms').toLowerCase()}`}
                                                                                                </label>
                                                                                            </div>
                                                                                        ) : /* Checkboxes fields - Multiple checkboxes */
                                                                                            (field.field_type === "checkboxes" || field.fieldtype === "checkboxes") ? (
                                                                                                fieldOptions.length > 0 ? (
                                                                                                    <div className={`mt-2 ${field.layout === 'row' ? 'd-flex gap-3' : ''}`}>
                                                                                                        {fieldOptions.map((option, optionIndex) => {
                                                                                                            // Normalize option to object format if it's a string
                                                                                                            const optionData = typeof option === 'string'
                                                                                                                ? { label: option, value: option, imageUrl: null }
                                                                                                                : option;

                                                                                                            return (
                                                                                                                <div key={optionIndex} className="form-check">
                                                                                                                    <input
                                                                                                                        type="checkbox"
                                                                                                                        className="form-check-input"
                                                                                                                        disabled
                                                                                                                    />
                                                                                                                    <label className="form-check-label d-flex align-items-start gap-2">
                                                                                                                        <span>{String(optionData.label || 'Option')}</span>
                                                                                                                        {optionData.imageUrl && (
                                                                                                                            <ImageOptionPreview
                                                                                                                                imageUrl={optionData.imageUrl}
                                                                                                                                label={optionData.label}
                                                                                                                            />
                                                                                                                        )}
                                                                                                                    </label>
                                                                                                                </div>
                                                                                                            );
                                                                                                        })}
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <div className="form-check">
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            className="form-check-input"
                                                                                                            disabled
                                                                                                        />
                                                                                                        <label className="form-check-label">Multiple checkbox option (configure options above)</label>
                                                                                                    </div>
                                                                                                )
                                                                                            ) : /* Toggle/Switch fields */
                                                                                                (field.field_type === "toggle" || field.fieldtype === "toggle") ? (
                                                                                                    <div className="form-check form-switch">
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            className="form-check-input"
                                                                                                            disabled
                                                                                                        />
                                                                                                        <label className="form-check-label">
                                                                                                            {field.labelOn || 'Yes'} / {field.labelOff || 'No'}
                                                                                                        </label>
                                                                                                    </div>

                                                                                                ) : /* Header fields */
                                                                                                    (field.field_type === "header" || field.fieldtype === "header") ? (
                                                                                                        <div className="header-preview-container">
                                                                                                            <div className="border-bottom pb-2 mb-2">
                                                                                                                <h4 className="text-primary mb-0">
                                                                                                                    {field.label || field.fieldName || "Section Header"}
                                                                                                                </h4>
                                                                                                                {field.help_text && (
                                                                                                                    <small className="text-muted d-block mt-1">{field.help_text}</small>
                                                                                                                )}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ) : /* Signature fields */
                                                                                                        (field.field_type === "signature" || field.fieldtype === "signature") ? (
                                                                                                            <div className="signature-preview-container">
                                                                                                                <div className="border rounded p-3 bg-light text-center" style={{ minHeight: '120px', border: '2px dashed #dee2e6' }}>
                                                                                                                    <div className="d-flex flex-column justify-content-center align-items-center h-100">
                                                                                                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-muted mb-2">
                                                                                                                            <path d="M12 19l7-7 3 3-7 7-3-3z" />
                                                                                                                            <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
                                                                                                                            <path d="M2 2l7.586 7.586" />
                                                                                                                            <circle cx="11" cy="11" r="2" />
                                                                                                                        </svg>
                                                                                                                        <small className="text-muted">Signature pad</small>
                                                                                                                        <small className="text-muted">Click here to sign</small>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                {/* Show validation preview for required signature */}
                                                                                                                {field.required && field.validation?.required_message && (
                                                                                                                    <div className="validation-preview mt-1">
                                                                                                                        <small className="text-danger d-block">
                                                                                                                            <strong>Validation:</strong> {field.validation.required_message}
                                                                                                                        </small>
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </div>

                                                                                                        ) : /* Formula field preview rendering */
                                                                                                            (field.field_type === "formula" || field.fieldtype === "formula") ? (
                                                                                                                <div className="formula-preview-container">
                                                                                                                    <div className="input-group">
                                                                                                                        {field.prefix && (
                                                                                                                            <span className="input-group-text">{field.prefix}</span>
                                                                                                                        )}
                                                                                                                        <Form.Control
                                                                                                                            type="text"
                                                                                                                            value={field.calculated_value || '0.00'}
                                                                                                                            readOnly
                                                                                                                            disabled
                                                                                                                            className="bg-light"
                                                                                                                        />
                                                                                                                        {field.suffix && (
                                                                                                                            <span className="input-group-text">{field.suffix}</span>
                                                                                                                        )}
                                                                                                                    </div>

                                                                                                                    {field.show_formula && field.formula_expression && (
                                                                                                                        <Form.Text className="text-muted font-monospace d-block mt-1">
                                                                                                                            Formula: {field.formula_expression}
                                                                                                                        </Form.Text>
                                                                                                                    )}

                                                                                                                    {field.help_text && (
                                                                                                                        <Form.Text className="text-muted d-block mt-1">
                                                                                                                            {field.help_text}
                                                                                                                        </Form.Text>
                                                                                                                    )}

                                                                                                                    <div className="input-type-preview mt-1">
                                                                                                                        <small className="text-info d-block">
                                                                                                                            <strong>Field Type:</strong> Calculated field (read-only)
                                                                                                                        </small>
                                                                                                                        {field.formula_error && (
                                                                                                                            <small className="text-danger d-block">
                                                                                                                                <strong>Error:</strong> {field.formula_error}
                                                                                                                            </small>
                                                                                                                        )}
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                            ) : /* Default input fields */
                                                                                                                (
                                                                                                                <>
                                                                                                                    <Form.Control
                                                                                                                        type={field.field_type === "email" || field.fieldtype === "email" ? "email" :
                                                                                                                            field.field_type === "number" || field.fieldtype === "number" ? "number" :
                                                                                                                                field.field_type === "date" || field.fieldtype === "date" ? "date" :
                                                                                                                                    field.field_type === "time" || field.fieldtype === "time" ? "time" :
                                                                                                                                        field.field_type === "datetime" || field.fieldtype === "datetime" ? "datetime-local" :
                                                                                                                                            field.field_type === "phone" || field.fieldtype === "phone" ? "tel" :
                                                                                                                                                field.field_type === "url" || field.fieldtype === "url" ? "url" : "text"}
                                                                                                                        placeholder={field.placeholder || `Enter ${(field.label || field.fieldName).toLowerCase()}...`}
                                                                                                                        disabled
                                                                                                                        min={field.min_value}
                                                                                                                        max={field.max_value}
                                                                                                                        step={field.step}
                                                                                                                        minLength={field.min_length}
                                                                                                                        maxLength={field.max_length}
                                                                                                                        pattern={field.validation?.pattern || undefined}
                                                                                                                        title={field.validation?.pattern ? field.validation?.pattern_message : undefined}
                                                                                                                    />
                                                                                                                    {/* Show validation preview for required fields */}
                                                                                                                    {field.required && field.validation?.required_message && (
                                                                                                                        <div className="validation-preview mt-1">
                                                                                                                            <small className="text-danger d-block">
                                                                                                                                <strong>Validation:</strong> {field.validation.required_message}
                                                                                                                            </small>
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                    {/* Show number input enforcement message */}
                                                                                                                    {(field.field_type === "number" || field.fieldtype === "number") && (
                                                                                                                        <div className="input-type-preview mt-1">
                                                                                                                            <small className="text-info d-block">
                                                                                                                                <strong>Input Type:</strong> Only numbers allowed
                                                                                                                                {field.min_value && ` (min: ${field.min_value})`}
                                                                                                                                {field.max_value && ` (max: ${field.max_value})`}
                                                                                                                                {field.step && ` (step: ${field.step})`}
                                                                                                                            </small>
                                                                                                                            {field.validation?.invalid_number_message && (
                                                                                                                                <small className="text-danger d-block">
                                                                                                                                    <strong>Validation:</strong> {field.validation.invalid_number_message}
                                                                                                                                </small>
                                                                                                                            )}
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                    {/* Show email input enforcement message */}
                                                                                                                    {(field.field_type === "email" || field.fieldtype === "email") && (
                                                                                                                        <div className="input-type-preview mt-1">
                                                                                                                            <small className="text-info d-block">
                                                                                                                                <strong>Input Type:</strong> Email format enforced
                                                                                                                            </small>
                                                                                                                            {field.validation?.invalid_email_message && (
                                                                                                                                <small className="text-danger d-block">
                                                                                                                                    <strong>Validation:</strong> {field.validation.invalid_email_message}
                                                                                                                                </small>
                                                                                                                            )}
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                    {/* Show phone input enforcement message */}
                                                                                                                    {(field.field_type === "phone" || field.fieldtype === "phone") && (
                                                                                                                        <div className="input-type-preview mt-1">
                                                                                                                            <small className="text-info d-block">
                                                                                                                                <strong>Input Type:</strong> Phone number format
                                                                                                                            </small>
                                                                                                                            {field.validation?.invalid_phone_message && (
                                                                                                                                <small className="text-danger d-block">
                                                                                                                                    <strong>Validation:</strong> {field.validation.invalid_phone_message}
                                                                                                                                </small>
                                                                                                                            )}
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                    {/* Show URL input enforcement message */}
                                                                                                                    {(field.field_type === "url" || field.fieldtype === "url") && (
                                                                                                                        <div className="input-type-preview mt-1">
                                                                                                                            <small className="text-info d-block">
                                                                                                                                <strong>Input Type:</strong> URL format enforced
                                                                                                                            </small>
                                                                                                                            {field.validation?.invalid_url_message && (
                                                                                                                                <small className="text-danger d-block">
                                                                                                                                    <strong>Validation:</strong> {field.validation.invalid_url_message}
                                                                                                                                </small>
                                                                                                                            )}
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                    {/* Show text length validation */}
                                                                                                                    {(field.field_type === 'text' || field.field_type === 'textarea' || field.fieldtype === 'text' || field.fieldtype === 'textarea') &&
                                                                                                                        (field.min_length || field.max_length) && (
                                                                                                                            <div className="input-validation-preview mt-1">
                                                                                                                                <small className="text-info d-block">
                                                                                                                                    <strong>Length:</strong>
                                                                                                                                    {field.min_length && ` Min ${field.min_length} chars`}
                                                                                                                                    {field.min_length && field.max_length && ','}
                                                                                                                                    {field.max_length && ` Max ${field.max_length} chars`}
                                                                                                                                </small>
                                                                                                                            </div>
                                                                                                                        )}
                                                                                                                    {/* Show pattern validation */}
                                                                                                                    {field.validation?.pattern &&
                                                                                                                        (field.field_type === 'text' || field.field_type === 'textarea' ||
                                                                                                                            field.field_type === 'number' || field.field_type === 'phone' ||
                                                                                                                            field.fieldtype === 'text' || field.fieldtype === 'textarea' ||
                                                                                                                            field.fieldtype === 'number' || field.fieldtype === 'phone') && (
                                                                                                                            <div className="pattern-preview mt-1">
                                                                                                                                <small className="text-warning d-block">
                                                                                                                                    <strong>Pattern:</strong> {field.validation.pattern}
                                                                                                                                </small>
                                                                                                                                {field.validation?.pattern_message && (
                                                                                                                                    <small className="text-danger d-block">
                                                                                                                                        <strong>Validation:</strong> {field.validation.pattern_message}
                                                                                                                                    </small>
                                                                                                                                )}
                                                                                                                            </div>
                                                                                                                        )}
                                                                                                                </>
                                                                                                            )}

                                                                    {/* Help text */}
                                                                    {field.help_text && (
                                                                        <Form.Text className="text-muted">{field.help_text}</Form.Text>
                                                                    )}

                                                                    {/* Character count for text fields */}
                                                                    {(field.field_type === 'text' || field.field_type === 'textarea') &&
                                                                        field.max_length && (
                                                                            <Form.Text className="text-muted">
                                                                                Max {field.max_length} characters
                                                                            </Form.Text>
                                                                        )}
                                                                </Form.Group>
                                                            </div>
                                                        );
                                                    })}

                                                {existingFormFields.length === 0 && (
                                                    <div className="col-12 text-center text-muted py-4">
                                                        <p>No fields to preview. Add some fields to see the preview.</p>
                                                    </div>
                                                )}
                                            </Row>
                                        </Form>
                                    </div>
                                </Col>
                            </Row>
                            : null}

                    </Container>
                </div>
            </div >

            {/* Master Data Preview Modal */}
            <MasterDataPreviewModal
                show={previewModalData.visible}
                onHide={() => setPreviewModalData({ ...previewModalData, visible: false })}
                fieldLabel={previewModalData.fieldLabel}
                options={previewModalData.options}
                tableName={previewModalData.tableName}
                columnName={previewModalData.columnName}
            />

        </>
    )
}

export default EditWebForm;
